<template>
  <div class="chatWrapper">
    <el-row class="center" style="height:100%">
      <!-- 左侧 -->
      <!-- <el-button @click="demo">{{$t('other.a945')}}</el-button> -->
      <el-col :span="16" class="chat_ctn center" style="height:100%">
        <el-container style="height: 100%">
          <el-aside
            class="border scrollbar"
            style="width: 30%; padding: 0px"
            v-if="tab"
          >
            <el-row style="height: 2.5rem">
              <el-col :span="24">
                <el-input
                  :placeholder="search_text"
                  v-model="searchFilters.queryString"
                  @change="search_()"
                >
                  <i
                    slot="suffix"
                    class="el-icon-search"
                    style="font-size: 1.5rem; margin-top: 0.5rem"
                    @click="search_"
                  ></i>
                  <el-select
                    v-model="select"
                    slot="prepend"
                    :placeholder="$t('allorders.pleasechoose')"
                    @change="search_()"
                  >
                    <el-option :label="$t('chat.Allthequery')" value="-1"></el-option>
                    <el-option :label="$t('chat.Querymessage')" value="0"></el-option>
                    <el-option :label="$t('chat.QueryingCustomername')" value="1"></el-option>
                  </el-select>
                </el-input>
              </el-col>
            </el-row>

            <el-row style="padding:10px 15px" >
      
              <el-col :span="21" style="padding-left: 0" >
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <b style="color: #606266; font-size: 1.1rem">{{ shopName }}</b><i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="dropdown_ctn">
                       <el-tree
                        :data="shopsGroupByRegion"
                        :props="defaultProps"
                        accordion
                        style="width:12rem"
                        @node-click="handleShopClick"
                        @node-contextmenu="talkShopMenu($event)"
                        >
                      </el-tree>
                    <el-dropdown-item @click.native ="authorizes" icon="el-icon-circle-plus">{{$t('chat.Authorizedshops')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <el-col :span="3" class="center" >
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i
                      class="el-icon-finished"
                      style="font-size: 25px; color: #606266"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="filters.isRead == 0 ? '1' : '0'"
                      :icon="filters.isRead == 0 ? 'el-icon-check' : ''"
                      >{{$t('chat.Allunreadmessages')}}</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="filters.pinned == true ? 'false' : 'true'"
                      :icon="filters.pinned == true ? 'el-icon-check' : ''"
                      >{{$t('chat.Topnews')}}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>

            <el-row
              style="height: 33.5rem"
              v-if="select == '-1' || select == '1'"
            >
              <div
                @scroll="talkConcersationScroll($event)"
                id="scrolldShopList"
                style="over-flow：auto"
                class="talks-container"
                ref="firstWrapper"
              >
                <div
                  style="height: 4rem"
                  :class="selects == index ? 'clickOn' : ''"
                  v-for="(item, index) in conversationList"
                  :key="index"
                  @click="conversation(item, index)"
                  @contextmenu.prevent="talkItemsMenu(item, $event)"
                >
                  <el-row :class="mouseover">
                    <el-col :span="1" style="height: 4rem">
                      <i
                        class="el-icon-star-on"
                        style="color: #e6a23c; font-size: 1rem"
                        v-show="item.pinned == 'true'"
                      ></i>
                    </el-col>
                    <el-col :span="4" class="center" style="height: 4rem">
                      <el-image
                        v-if="item.toAvatar != ''"
                        :src="item.toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col
                      :span="19"
                      style="height: 1.3rem; padding-left: 0.6rem"
                    >
                      <el-row style="height: 2rem; padding-top: 0.45rem">
                        <el-col :span="18">
                          <b
                            style="
                              font-size: 14px;
                              color: #606266;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              white-space: nowrap;
                              width: 9rem;
                            "
                            class="left"
                            >{{ item.toName }}
                          </b>
                        </el-col>
                        <el-col :span="6" class="center" style="height: 2rem">
                          <el-badge
                            :value="item.unreadCount"
                            :hidden="
                              (item.isRead == 1 && item.unreadCount == 0) ||
                              item.isRead == null
                            "
                            :max="99"
                            class="item"
                            :is-dot="
                              (item.isRead == 0 && item.unreadCount == 0) ||
                              (item.isRead == null && item.unreadCount == 0)
                            "
                          >
                            <el-row style="height: 1px; width: 1px"></el-row>
                          </el-badge>
                        </el-col>
                      </el-row>
                      <el-row style="height: 1.3rem">
                        <el-col :span="14" style="height: 1rem">
                          <span
                            style="color: #606266; font-size: 0.8rem"
                            class="left word"
                            >{{
                              item.latestMessageType == "text"
                                ? item.latestMessageContent
                                : latestMessageType[item.latestMessageType]
                            }}</span
                          >
                        </el-col>
                        <el-col :span="10" style="padding-top: 0.2rem">
                          <span
                            style="color: #606266; font-size: 0.7rem"
                            class="right"
                          >
                            {{ item.time }}
                          </span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-row>

            <el-row style="height: 33.5rem" v-if="select == '0'">
              <div
                @scroll="talkMessageScroll($event)"
                id="scrolldShopList"
                style="over-flow：auto"
                class="talks-container"
              >
                <div
                  style="height: 4rem"
                  :class="selects == index ? 'clickOn' : ''"
                  v-for="(item, index) in conversationList"
                  :key="index"
                  @click="getAllConversationHistory(item, index)"
                  @contextmenu.prevent="talkItemsMenu(item, $event)"
                >
                  <el-row :class="mouseover">
                    <el-col :span="1" style="height: 4rem"> </el-col>
                    <el-col :span="4" class="center" style="height: 4rem">
                      <el-image
                        v-if="item.toAvatar != ''"
                        :src="item.toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col
                      :span="19"
                      style="height: 2.3rem; padding-left: 0.7rem"
                    >
                      <el-row style="height: 2rem; padding-top: 7px">
                        <el-col :span="18">
                          <b style="font-size: 14px; color: #606266">{{
                            item.toName
                          }}</b>
                        </el-col>
                        <el-col :span="6" class="center" style="height: 2rem">
                        </el-col>
                      </el-row>
                      <el-row style="height: 20px">
                        <el-col :span="16" style="height: 15px">
                          <span
                            style="color: #606266; font-size: 12px"
                            class="left word"
                            v-html="item.hitMessage"
                          ></span>
                        </el-col>
                        <el-col :span="8" style="padding-top: 3px">
                          <span
                            style="color: #606266; font-size: 12px"
                            class="right"
                          >
                            {{ getConversationsTime(item.createdTime) }}
                          </span>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-row>
          </el-aside>

          <el-aside class="scrollbar border" style="width: 30%" v-else>
            <el-scrollbar style="height: 100%">
              <el-row>
                <div>
                  <el-button
                    el-button
                    style="width: 100%; height: 4rem; font-size: 16px"
                    @click="authorizes"
                    ><i class="el-icon-circle-plus"></i
                    ><b>{{$t('chat.Pleasefirst')}}</b></el-button
                  >
                </div>
                <div
                  style="height: 4rem"
                  v-for="(item, index) in authorizedShopList"
                  :key="index"
                >
                  <el-button
                    style="padding: 0.67rem; height: 100%; width: 100%"
                    @click="enter(item)"
                    @contextmenu.prevent.native="talkShopMenu(item, $event)"
                  >
                    <el-badge :is-dot="item.unread" class="item">
                      <b style="font-size: 20px">{{ item.shopName }}</b>
                    </el-badge>
                  </el-button>
                </div>
              </el-row>
            </el-scrollbar>
          </el-aside>

          <el-container >
            <el-header style="border-left: 0px" class="border">
              <b
                style="font-size: 18px; color: #606266; height: 100%"
                class="left mid"
                v-if="tab"
              >
                <span>{{ conversationData.toName }}</span>
                
              </b>
              <span style="font-size: 18px; color: #606266; height: 100%; margin-left:10px" class="left mid">
                <el-button type="primary" round  size="mini" @click="opentoname">{{$t('chat.Managementgroup')}}</el-button>
              </span>
              <span style="font-size: 18px; color: #606266; height: 100%; margin-left:10px" class="left mid">
                <el-button type="warning" round  size="mini" @click="synchronously">{{$t('chat.Synchronizesessions')}}</el-button>
              </span>
              <span style="font-size: 18px; color: #606266; height: 100%; margin-left:10px" class="left mid">
                <el-tag
              type="info"
  v-for="tag in tags"
  :key="tag.categoryId"
  style="margin-left:10px"
  >
  {{tag.categoryName}}
</el-tag></span>
              <span style="font-size: 18px; color: #606266; height: 100%;z-index:99999"
                ><el-alert
    :title="$t('chat.Clickon')"
    type="info">
  </el-alert></span>
            </el-header>
            <!-- <span style="height:100%;margin-right:0.67rem" class="right mid" >
                          <el-button type="text">
                              <i class="el-icon-s-tools" style="font-size:20px"></i>
                          </el-button>    
                      </span>                            

                      <span style="height:100%;margin-right:0.67rem" class="right mid">
                          <p style="font-size:14px">
                              assign to chuan wang
                          </p>    
                      </span>
                      <span style="height:100%;margin-right:0.67rem" class="right mid">
                          <el-button>
                              assign
                          </el-button>    
                      </span> -->

            <el-main
              class="scrollbar"
              height="13.3rem"
              style="over-flow：auto;padding:0px"
            >

              <div
                id="scrolldIV"
                class="talks-container lum-scrollbar"
                @scroll="talkPanelScroll($event)"
                style="over-flow：auto"
                v-loading="chatLoading&&tab"
              >
                <div style="height:7rem"></div>

                <div
                  ref="chat"
                  v-for="(item, index) in conversationHistory"
                  :key="conversationHistory[index].content + index+item.messageId"
                  v-if="tab"
                >
                
                  <!-- 客服文字信息 -->
                  
                  <el-row
                    class="top"
                    v-if="
                      shopId == item.fromShopId &&
                      item.messageType == 'text' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                  <div class="tex-tare">
                        <div class="tex-one" @click="tarcn(item)">{{$t('chat.Chinese')}}</div>
                        <div class="tex-two" @click="taren(item)">{{$t('chat.English')}}</div>
                  </div>
                    <el-col :span="22">
                      <el-dropdown trigger="click" class="right">
                        
                        <span class="el-dropdown-link">
                          <text-message
                            :content="item.content"
                            float="right"
                            :full-width="true"
                            :arrow="true"
                          />
                          <el-row>
                            <span
                              class="right"
                              style="font-size: 12px; color: #606266"
                              >{{ item.time }}</span
                            >
                          </el-row>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'en'"
                            @click.native="translation(item, index, 'en',item.messageId)"
                            >{{$t('chat.intoEnglish')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'vi'"
                            @click.native="translation(item, index, 'vi',item.messageId)"
                            >{{$t('chat.intoVietnamese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'zh-cn'"
                            @click.native="translation(item, index, 'zh-cn',item.messageId)"
                            >{{$t('chat.intoChinese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'id'"
                            @click.native="translation(item, index, 'id',item.messageId)"
                            >{{$t('chat.intoIndonesian')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'es'"
                            @click.native="translation(item, index, 'es',item.messageId)"
                            >{{$t('chat.intoSpanish')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'pt'"
                            @click.native="translation(item, index, 'pt',item.messageId)"
                            >{{$t('chat.intoPortuguese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != ''"
                            @click.native="translation(item, index, '',item.messageId)"
                            v-if="item.content_ != undefined"
                            >{{$t('chat.original')}}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                    <el-col :span="2" class="center" style="padding-left: 1rem">
                      <i
                        class="iconfont icon-kefucopy"
                        style="font-size: 28px; color: orange"
                      ></i>
                    </el-col>
                  </el-row>
                  <!-- 客服产品信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId == item.fromShopId &&
                      item.messageType == 'item' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col :span="22">
                      <el-row>
                        <el-card style="width: 50%" class="right">
                          <el-row style="font-size: 14px">{{$t('chat.commodity')}}</el-row>
                          <el-row style="margin-top: 0.67rem">
                            <el-col :span="6">
                              <el-image
                                :src="
                                  stringToJson(item.content).image
                                    .image_url_list[0]
                                "
                                style="width: 3rem; height: 3rem"
                              ></el-image>
                            </el-col>
                            <el-col :span="18">
                              <a
                                style="
                                  display: block;
                                  overflow: hidden;
                                  word-break: keep-all;
                                  white-space: nowrap;
                                  text-overflow: ellipsis;
                                  font-size: 12px;
                                  padding-bottom: 0.67rem;
                                  padding-top: 0.3rem;
                                  width: 12rem;
                                "
                                :href="
                                  'https://th.xiapibuy.com/product/' +
                                  shopId +
                                  '/' +
                                  stringToJson(item.content).item_id
                                "
                                target="view_window"
                                >{{ stringToJson(item.content).item_name }}</a
                              >
                              <p style="font-size: 12px">
                                ฿{{ stringToJson(item.content).price }}
                              </p>
                            </el-col>
                          </el-row>
                        </el-card>
                      </el-row>
                      <el-row>
                        <span
                          class="right"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                    <el-col :span="2" class="center" style="padding-left: 1rem">
                      <i
                        class="iconfont icon-kefucopy"
                        style="font-size: 28px; color: orange"
                      ></i>
                    </el-col>
                  </el-row>
                  <!-- 用户产品信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId != item.fromShopId &&
                      item.messageType == 'item' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col
                      :span="2"
                      class="center"
                      style="padding-right: 1rem"
                    >
                      <el-image
                        v-if="toAvatar != ''"
                        style="width: 35px; height: 35px; border-radius: 50%"
                        :src="toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col :span="22">
                      <el-row>
                        <el-card style="width: 50%" class="left">
                          <el-row style="font-size: 14px">{{$t('chat.product')}}</el-row>
                          <el-row style="margin-top: 0.67rem">
                            <el-col :span="6">
                              <el-image
                                :src="
                                  stringToJson(item.content).image
                                    .image_url_list[0]
                                "
                                style="width: 3rem; height: 3rem"
                              ></el-image>
                            </el-col>
                            <el-col :span="18">
                              ฿{{ stringToJson(item.content).price  }}
                              <a
                                style="
                                  text-overflow: ellipsis;
                                  overflow: hidden;
                                  white-space: nowrap;
                                  font-size: 12px;
                                  padding-bottom: 0.67rem;
                                  padding-top: 5px;
                                  color: #409eff;
                                 
                                "
                                :href="
                                  'https://th.xiapibuy.com/product/' +
                                  shopId +
                                  '/' +
                                  stringToJson(item.content).item_id
                                "
                                >{{
                                  stringToJson(item.content).item_name
                                }}</a
                              >
                              
                            </el-col>
                          </el-row>
                        </el-card>
                      </el-row>
                      <el-row>
                        <span
                          class="left"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                  </el-row>
                  <!-- 用户订单信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId != item.fromShopId &&
                      item.messageType == 'order' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col
                      :span="2"
                      class="center"
                      style="padding-right: 1rem"
                    >
                      <el-image
                        v-if="toAvatar != ''"
                        style="width: 2.33rem; height: 35px; border-radius: 50%"
                        :src="toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col :span="22">
                      <el-row>
                        <el-card style="width: 20rem" class="left">
                          <el-row style="font-size: 14px">{{$t('chat.order')}}</el-row>

                          <el-row
                            style="margin-top: 0.67rem"
                            v-for="(item_, index_) in stringToJson(item.content)
                              .item_list"
                            :key="index_"
                          >
                            <el-col :span="6">
                              <el-image
                                :src="item_.detail[0].image.image_url_list[0]"
                                style="width: 3rem; height: 3rem"
                              ></el-image>
                            </el-col>
                            <el-col :span="18">
                              <el-row style="font-size: 12px">
                                <b>{{
                                  translateData[
                                    stringToJson(item.content).order_status
                                  ]
                                }}</b>
                              </el-row>
                              <el-row>
                                <p
                                  style="
                                    display: block;
                                    overflow: hidden;
                                    word-break: keep-all;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    font-size: 12px;
                                    padding-bottom: 0.67rem;
                                    padding-top: 0.3rem;
                                    width: 12rem;
                                  "
                                  :href="
                                    'https://th.xiapibuy.com/product/' +
                                    shopId +
                                    '/' +
                                    item_.item_id
                                  "
                                  target="view_window"
                                >
                                  {{ item_.item_name }}
                                </p>
                              </el-row>
                              <el-row>
                                <b style="font-size: 12px"
                                  >x{{ item_.model_quantity_purchased }}</b
                                >
                              </el-row>
                            </el-col>
                          </el-row>

                          <el-row style="padding: 0.67rem 0px 0.67rem 0px">
                            <el-col :span="12" style="font-size: 12px">
                              {{$t('homeTwo.SubInspection')}}
                            </el-col>
                            <el-col :span="12">
                              <span class="right" style="font-size: 12px">{{
                                stringToJson(item.content).order_sn
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row style="padding: 0.67rem 0px 0.67rem 0px">
                            <el-col :span="10">
                              <span style="font-size: 12px">
                                {{$t('chat.Ordercreationtime')}}
                              </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).create_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                                'COMPLETED' ||
                              stringToJson(item.content).order_status ==
                                'SHIPPED' ||
                              stringToJson(item.content).order_status ==
                                'READY_TO_SHIP' ||
                              stringToJson(item.content).order_status ==
                                'REFUND'
                            "
                          >
                            <el-col :span="12" style="font-size: 12px">
                              {{$t('homeTwo.Totalpayment')}}
                            </el-col>
                            <el-col :span="12">
                              <span class="right" style="font-size: 12px"
                                >{{item.region == 'TH'?'฿':'' || item.region == 'MY'?'RM':'' || item.region == 'PH'?'P':'' || item.region == 'ID'?'RP':'' || item.region == 'VN'?'VND':''}}{{
                                  stringToJson(item.content).total_amount
                                }}</span
                              >
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                                'COMPLETED' ||
                              stringToJson(item.content).order_status ==
                                'SHIPPED' ||
                              stringToJson(item.content).order_status ==
                                'READY_TO_SHIP' ||
                              stringToJson(item.content).order_status ==
                                'REFUND'
                            "
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('homeTwo.Logistics')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px"
                                >Standard Delivery - ส่งธรรมดาในประเทศ</span
                              >
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="item.order_status == 'COMPLETED'"
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('homeTwo.Completetime')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).update_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                              'READY_TO_SHIP'
                            "
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('chat.DatetoPull')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).ship_by_date
                                )
                              }}</span>
                            </el-col>
                          </el-row>
                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                              'CANCELLED'
                            "
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('pendingorder.cancelTime')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).update_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>
                        </el-card>
                      </el-row>

                      <el-row>
                        <span
                          class="left"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                  </el-row>
                  <!-- 客服订单信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId == item.fromShopId &&
                      item.messageType == 'order' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col :span="22">
                      <el-row>
                        <el-card style="width: 20rem" class="right">
                          <el-row style="font-size: 14px">{{$t('chat.order')}}</el-row>
                          <el-row
                            style="margin-top: 0.67rem"
                            v-for="(item_, index_) in stringToJson(item.content)
                              .item_list"
                            :key="index_"
                          >
                            <el-col :span="6">
                              <el-image
                                :src="item_.detail[0].image.image_url_list[0]"
                                style="width: 3rem; height: 3rem"
                              ></el-image>
                            </el-col>
                            <el-col :span="18">
                              <el-row style="font-size: 12px">
                                <b>{{
                                  translateData[
                                    stringToJson(item.content).order_status
                                  ]
                                }}</b>
                              </el-row>
                              <el-row>
                                <a
                                  style=" display: block; overflow: hidden; word-break: keep-all;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    font-size: 12px;
                                    padding-bottom: 0.67rem;
                                    padding-top: 0.3rem;
                                    width: 12rem;
                                  "
                                  :href="
                                    'https://th.xiapibuy.com/product/' +
                                    shopId +
                                    '/' +
                                    item_.item_id
                                  "
                                  target="view_window"
                                >
                                  {{ item_.item_name }}
                                </a>
                              </el-row>
                              <el-row>
                                <b style="font-size: 12px"
                                  >x{{ item_.model_quantity_purchased }}</b
                                >
                              </el-row>
                            </el-col>
                          </el-row>

                          <el-row style="padding: 0.67rem 0px 0.67rem 0px">
                            <el-col :span="12" style="font-size: 12px">
                              {{$t('homeTwo.SubInspection')}}
                            </el-col>
                            <el-col :span="12">
                              <span class="right" style="font-size: 12px"
                                >{{ stringToJson(item.content).order_sn }}
                                <i
                                  class="el-icon-copy-document"
                                  @click="
                                    copyorders(
                                      stringToJson(item.content).order_sn
                                    )
                                  "
                                  style="cursor: pointer; color: #409eff"
                                ></i>
                              </span>
                            </el-col>
                          </el-row>

                          <el-row style="padding: 0.67rem 0px 0.67rem 0px">
                            <el-col :span="10">
                              <span style="font-size: 12px">
                                {{$t('chat.Ordercreationtime')}}
                              </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).create_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                                'COMPLETED' ||
                              stringToJson(item.content).order_status ==
                                'SHIPPED' ||
                              stringToJson(item.content).order_status ==
                                'READY_TO_SHIP' ||
                              stringToJson(item.content).order_status ==
                                'REFUND'
                            "
                          >
                            <el-col :span="12" style="font-size: 12px">
                              {{$t('homeTwo.Totalpayment')}}
                            </el-col>
                            <el-col :span="12">
                              <span class="right" style="font-size: 12px"
                                >{{item.region == 'TH'?'฿':'' || item.region == 'MY'?'RM':'' || item.region == 'PH'?'P':'' || item.region == 'ID'?'RP':'' || item.region == 'VN'?'VND':''}}{{
                                  stringToJson(item.content).total_amount
                                }}</span
                              >
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="item.order_status == 'COMPLETED'"
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('homeTwo.Completetime')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                
                                stringTime(
                                  stringToJson(item.content).update_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                              'READY_TO_SHIP'
                            "
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('chat.DatetoPull')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).ship_by_date
                                )
                                
                              }}</span>
                            </el-col>
                          </el-row>

                          <el-row
                            style="padding: 0.67rem 0px 0.67rem 0px"
                            v-if="
                              stringToJson(item.content).order_status ==
                              'CANCELLED'
                            "
                          >
                            <el-col :span="10">
                              <span style="font-size: 12px"> {{$t('pendingorder.cancelTime')}} </span>
                            </el-col>
                            <el-col :span="14">
                              <span class="right" style="font-size: 12px">{{
                                stringTime(
                                  stringToJson(item.content).update_time
                                )
                              }}</span>
                            </el-col>
                          </el-row>
                        </el-card>
                      </el-row>
                      <el-row>
                        <span
                          class="right"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                    <el-col :span="2" class="center" style="padding-left: 1rem">
                      <i
                        class="iconfont icon-kefucopy"
                        style="font-size: 28px; color: orange"
                      ></i>
                    </el-col>
                  </el-row>

                  <!-- 客服图片信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId == item.fromShopId &&
                      item.messageType == 'image' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col :span="22" style="height: 200px">
                      <el-row>
                        <image-message :src="item.content" class="right" />
                      </el-row>
                      <el-row>
                        <span
                          class="right"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                    <el-col :span="2" class="center" style="padding-left: 1rem">
                      <i
                        class="iconfont icon-kefucopy"
                        style="font-size: 28px; color: orange"
                      ></i>
                    </el-col>
                  </el-row>
                  <!-- 用户文字信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId != item.fromShopId &&
                      item.messageType == 'text' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                   <div class="tex-tare-yh">
                        <div class="tex-one" @click="tarcn(item)">{{$t('chat.Chinese')}}</div>
                        <div class="tex-two" @click="taren(item)">{{$t('chat.English')}}</div>
                      </div>
                    <el-col
                      :span="2"
                      class="center"
                      style="padding-right: 1rem"
                    >
                      <el-image
                        v-if="toAvatar != ''"
                        style="width: 35px; height: 35px; border-radius: 50%"
                        :src="toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col :span="22">
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                          <text-message
                            :content="item.content"
                            float="left"
                            :full-width="true"
                            :arrow="true"
                          />
                          <el-row>
                            <span
                              span
                              class="left"
                              style="font-size: 12px; color: #606266"
                              >{{ item.time }}</span
                            >
                          </el-row>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'en'"
                            @click.native="translation(item, index, 'en',item.messageId)"
                            >{{$t('chat.intoEnglish')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'vi'"
                            @click.native="translation(item, index, 'vi',item.messageId)"
                            >{{$t('chat.intoVietnamese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'zh-cn'"
                            @click.native="translation(item, index, 'zh-cn',item.messageId)"
                            >{{$t('chat.intoChinese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'id'"
                            @click.native="translation(item, index, 'id',item.messageId)"
                            >{{$t('chat.intoIndonesian')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'es'"
                            @click.native="translation(item, index, 'es',item.messageId)"
                            >{{$t('chat.intoSpanish')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != 'pt'"
                            @click.native="translation(item, index, 'pt',item.messageId)"
                            >{{$t('chat.intoPortuguese')}}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-plus"
                            v-show="item.toLanguage != ''"
                            @click.native="translation(item, index, '',item.messageId)"
                            v-if="item.content_ != undefined"
                            >{{$t('chat.original')}}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                  <!-- 用户图片信息 -->
                  <el-row
                    class="top"
                    v-if="
                      shopId != item.fromShopId &&
                      item.messageType == 'image' &&
                      item.content != null &&
                      item.content != ''
                    "
                  >
                    <el-col :span="2" class="center" style="padding-left: 1rem">
                      <el-image
                        v-if="toAvatar != ''"
                        style="width: 35px; height: 35px; border-radius: 50%"
                        :src="toAvatar"
                        fit="fill"
                      ></el-image>
                      <i
                        v-else
                        class="iconfont icon-kehuAx"
                        style="font-size: 28px; color: #409eff"
                      ></i>
                    </el-col>
                    <el-col
                      :span="22"
                      style="height: 200px; padding-left: 20px"
                    >
                      <image-message :src="item.content" />

                      <el-row>
                        <span
                          class="left"
                          style="font-size: 12px; color: #606266"
                          >{{ item.time }}</span
                        >
                      </el-row>
                    </el-col>
                  </el-row>

                  <el-row
                  v-if="item.messageType == 'sticker' &&item.content != null &&
                      item.content != '' && shopId != item.fromShopId ">
                    <el-image
                        
                        style="width: 80px; height: 80px;margin-top:20px;float:right;margin-right:40px"
                        :src="item.content"
                        fit="fill"
                      ></el-image>
                  </el-row>
                   <el-row
                  v-if="item.messageType == 'sticker' &&item.content != null &&
                      item.content != '' && shopId == item.fromShopId ">
                    <el-image
                        
                        style="width: 80px; height: 80px;margin-top:20px;float:right;margin-right:40px"
                        :src="item.content"
                        fit="fill"
                      ></el-image>
                  </el-row>
                </div>
                <div class="center-cc" style="width:100%;height:100%" v-show="tab==false">
                  <div style="margin-bottom:10px">
                    
                    <a href="https://mp.weixin.qq.com/s/izlMLlmLGx2EhHB0IF8sCA" target="_blank" rel="noopener noreferrer">{{$t('chat.why')}}</a>
                  </div>
                  <el-button
                    el-button
                    style="width: 50%; height: 4rem; font-size: 16px"
                    @click="authorizes"
                    ><i class="el-icon-circle-plus"></i
                    ><b>{{$t('chat.Pleasefirst')}}</b></el-button
                  >
                </div>
              </div>



            </el-main>
            <el-footer
              class="border"
              height="167px"
              style="padding: 0px; border-left: 0px; "
            >
              <el-row
                style="
                  border-bottom: 2px #f4f4f4 solid;
                  height: 30px;
                  justify-content: space-around;
                  display: flex;
                  align-items: center;
                  
                  padding-left: 0.67rem;
                "
              >
                <!-- 工具栏 -->
                <el-col :span="17">
                  <el-upload
                    class="upload-demo left"
                    ref="upload"
                    action="/"
                    :http-request="uploadFile_"
                    :auto-upload="true"
                    :show-file-list="false"
                    
                  >
                  <i
                      class="iconfont icon-xiangce"
                      style="font-size: 20px"
                    />
                  </el-upload>
                   <el-popover
                    placement="top"
                    
                    width="300"
                    trigger="click"
                   >
                   <div >
                      <img :src="face.url" alt="" v-for="(face,index) in sticker" :key="index" style="width:60px;height:60px;cursor: pointer;" @click="sendface(face)">
                   </div>
                   <i
                      class="iconfont icon-biaoqing  left"
                      style="font-size: 20px;margin-left:20px;cursor: pointer;"
                      slot="reference"
                      
                    />
                  </el-popover>

                  <el-popover
                    placement="top"
                    
                    width="200"
                    trigger="click"
                   >
                    <!-- <el-button type="primary" @click="getcustommessage">主要按钮</el-button> -->
                    <div class="mes">
                      <div style="margin-bottom:20px">
                      <span style="font-size:16px">{{$t('chat.reply')}}:</span>
                   <el-switch
            v-model="showStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="updateBrandStatus(showStatus)"
            />
             <div style="margin-top:6px"> <el-button  size="mini" round @click="openresponse" v-if="this.showStatus=='1'">{{$t('chat.Automaticsetting')}}</el-button></div>
                   </div>
                        <div class="mes-zdy" v-show="contentData.content!='' &&　contentData.content!=null">
                          <div style="margin:8px">{{contentData.content}}</div>
                          </div>
                        <div><el-button v-show="contentData.content!='' &&　contentData.content!=null"  type="primary" size="mini" style="margin-top:10px"  @click="editmessage" >{{$t('chat.Modifyreply')}}</el-button></div>
                        <div class="mes-add" v-show="contentData.content=='' || contentData.content==null" @click="addmessage"><el-button type="primary" >{{$t('chat.Addcontent')}}</el-button></div>
                    </div>
                     <el-button class="right" size="mini"  slot="reference" style="margin-right:60px;"  type="info" plain>{{$t('chat.response')}}</el-button>
                    <!-- <button class="right" size="mini"  slot="reference" style="margin-right:20px;">自动回复</button> -->
                   <!-- <i
                      class="iconfont icon-zidong  left"
                      style="font-size: 20px;margin-left:20px;cursor: pointer;"
                      slot="reference"
                    
                    /> -->
                  
                  </el-popover>
                  <el-dialog
                      :title="$t('chat.reply')"
                      :visible.sync="mes_content"
                      width="30%"
                      :before-close="handleClose">
                      <el-input
                        type="textarea"
                        :rows="3"
                        :placeholder="$t('chat.Pleasereply')"
                        v-model="textarea_content">
                      </el-input>
                      <span slot="footer" class="dialog-footer">
                        <el-button @click="closemes">{{$t('chat.cancel')}}</el-button>
                        <el-button type="primary" @click="addmes">{{$t('chat.confirm')}}</el-button>
                      </span>
                    </el-dialog>
                  
                    
                  
                </el-col>

                <el-col :span="7" style="padding-right: 0.67rem;display: flex;
		align-items: flex-start;
		justify-content: space-around;">
                  
                  <el-popover
                    placement="top"
                    v-model="pitch"
                    width="260"
                    trigger="manual"
                   >
                   
                   
                  <div v-for="(goods,index) in answerthree" :key="index" @click="chckeanswer(goods)" style="cursor:pointer;" class="message_sty">
                    <span>{{goods.answer}}</span>
                    <el-divider></el-divider>
                    
                  </div>
                  <!-- <div class="message_sty">
                    <div class="mess-one">精准匹配到的回复:</div>
                    <div class="mess-two" v-show="gridData!=''" @click="pitchmes(gridData)">
                      <div style="margin:8px">{{gridData}}</div>
                      </div>
                    <div  v-show="gridData==''">没有匹配到</div>
                  </div>

                  <div class="message_sty">
                    <div class="mess-one">机器学习推荐回复:</div> -->
                    <!-- <div class="mess-two" v-show="answerRecommend!=''" @click="pitchmes(gridData)" v-for="(anser,index) in answerRecommend" :key="index">
                      <div style="margin:8px" >{{anser}}</div>
                    </div> -->
                    <!-- <div class="mess-two" v-show="answerRecommend!=''" @click="openrecom">
                      <div style="margin:8px;cursor:pointer;" >查看匹配到的回复</div>
                    </div>
                    <div  v-show="answerRecommend==''">没有匹配到</div>
                  </div> -->
                   <!-- <el-table :data="gridData">
                    <el-table-column width="160"  label="精准匹配到的回复" >
                          <template slot-scope="scope">
                            <span style="margin-left: 10px" @click="pitchknow(scope.$index, scope.row)">{{ scope.row.answer }}</span>
                          </template>

                    </el-table-column>
                    
                    
                  </el-table> -->
                  <!-- <el-table :data="similarData">
                    <el-table-column width="160"  label="相似匹配到的回复" >
                          <template slot-scope="scope">
                            <span style="margin-left: 10px" @click="pitchknow(scope.$index, scope.row)">{{ scope.row.answer }}</span>
                          </template>

                    </el-table-column>
                    
                    
                  </el-table> -->
                   <el-button class="left"  slot="reference"  @click="openrecomdopr" size="mini" style="margin-right:20px;"  type="info" plain>{{$t('chat.Recommended')}}</el-button>
                  <!-- <button class="left"  slot="reference"  @click="openrecomdopr" size="mini" style="margin-right:20px;">推荐回复</button> -->
                   <!-- <i
                      class="iconfont icon-zhinengkefu1 left"
                      style="font-size: 20px;margin-left:20px;cursor: pointer;"
                      slot="reference"
                       @click="pitch = !pitch"
                    /> -->
                  </el-popover>
                  
                  <el-popover placement="top" width="500" trigger="manual" v-model="popoverVisible">
                    <el-row>
                      <div class="icons-fan">
                           <i class="el-icon-circle-close" style="cursor: pointer;" @click="closepov"></i>
                      </div>
                     
                      <el-tabs
                        v-model="shortcutGroup"
                        type="card"
                        @tab-remove="removeShortcutTab"
                        @tab-click="tabclick_kj()"
                      >
                        <el-tab-pane
                          v-for="(item, index) in shortcutGroupData"
                          :key="index + item.groupId"
                          :label="item.groupName"
                          :name="item.groupId"
                          closable
                        >
                          <el-row>
                            <el-col :span="19">
                              <el-input
                                :placeholder="item.groupName"
                                :disabled="modifyGroup"
                                v-model="modifyGroupName"
                              ></el-input>
                            </el-col>
                            <el-col :span="5">
                              <el-button
                                v-if="modifyGroup"
                                @click="modifyGroup = false"
                                >{{$t('homeTwo.Editname')}}</el-button
                              >
                              <el-button
                                v-else
                                @click="confirmModifyGroup(item)"
                                >{{$t('chat.Suretomodify')}}</el-button
                              >
                            </el-col>
                          </el-row>
                          <el-row style="height: 20rem; overflow: auto">
                            <el-row
                              v-for="(item_, index_) in shortcutMessageData"
                              :key="index_"
                            >
                              <el-row
                                style="
                                  padding: 0.5rem 0 0.5rem 0;
                                  background: #ebedf1;
                                  border-bottom: 2px solid #ffffff;
                                "
                                @click.native="textarea = item_.answer"
                              >
                                <el-col
                                  :span="15"
                                  style="padding: 0 1rem 0 1rem"
                                >
                                  <p v-if="ifModifyMessageIndex != index_">
                                    {{ item_.answer }}
                                  </p>
                                  <el-input
                                    v-else
                                    v-model="modifyMessage_"
                                    :placeholder="item_.answer"
                                    type="textarea"
                                    :rows="item_.answer.length / 20"
                                  ></el-input>
                                </el-col>
                                <el-col :span="9">
                                  <el-button
                                    @click.native.stop="amendEdit_kj(item_)"
                                    >{{$t('chat.modification')}}</el-button
                                  >
                                  <!-- <el-button
                                    @click.stop="modifyMessage(item_, index_)"
                                    v-else
                                    >{{$t('other.a166')}}</el-button
                                  > -->
                                  <el-button @click.stop="deleteMessage(item_)"
                                    >{{$t('chat.delete')}}</el-button
                                  >
                                </el-col>
                              </el-row>
                            </el-row>

                            <el-row style="height: 3rem">
                              <el-col :span="24">
                                <el-button
                                  type="text"
                                  style="font-size"
                                  @click="ifaddShortcutMessage_"
                                >
                                  {{$t('chat.AddquickReplies')}}
                                </el-button>
                              </el-col>
                            </el-row>
                          </el-row>
                        </el-tab-pane>
                        <el-tab-pane :closable="false">
                          <span slot="label">{{$t('chat.Addgroup')}}</span>
                          <el-row style="height: 20rem">
                            <el-col :span="20">
                              <el-input v-model="groupName"></el-input>
                            </el-col>
                            <el-col :span="4">
                              <el-button @click="addGroup">{{$t('chat.add')}}</el-button>
                            </el-col>
                          </el-row>
                        </el-tab-pane>
                      </el-tabs>
                      
                    </el-row>
                    <el-button class="right" slot="reference" @click="changepover" size="mini"  type="info" plain style="margin-right:30px">{{$t('chat.Fastreply')}}</el-button>
                    <!-- <button class="right" slot="reference" @click="changepover" size="mini">快捷回复</button> -->
                    <!-- <i
                      class="iconfont icon-kuaijiehuifuguanli right"
                      slot="reference"
                      style="font-size: 20px;cursor: pointer;"
                      @click="changepover"
                    ></i> -->
                  </el-popover>
                </el-col>
              </el-row>
              <!-- 机器学习回复 -->
              <el-dialog
  :title="$t('chat.Machineresponse')"
  :visible.sync="openrecomd"
  width="50%"
  :before-close="closerecon">
  <!-- <div class="mess-two" v-show="answerRecommend!=''" @click="pitchmes(gridData)" v-for="(anser,index) in answerRecommend" :key="index">
                      <div style="margin:8px" >{{anser}}</div>
                    </div> -->
  <el-scrollbar
        wrapClass="scrollbar-wrap"
        style="height:350px"
        ref="scrollbarContainer">
  <div v-if="answerRecommend==''">
      {{$t('chat.beenmatched')}}
  </div>
  <div v-for="(anser,index) in answerRecommend" :key="index">
    <span  @click="selectanswer(anser)" style="cursor:pointer;">{{anser.answer}}</span>
    <div class="answerbody">
         <el-button round size="mini" @click="langeone(anser,index)">{{language}}</el-button>
          <el-button round size="mini" @click="langetwo(anser,index)">{{toLanguage}}</el-button>
    </div>
    
    <el-divider></el-divider>
    
  </div>
  
</el-scrollbar>

  
  <span slot="footer" class="dialog-footer">
    <el-button @click="openrecomd = false">{{$t('chat.cancel')}}</el-button>
    <el-button type="primary" @click="openrecomd = false">{{$t('chat.confirm')}}</el-button>
  </span>
</el-dialog>

 <!-- 机器学习回复 -->
              <el-dialog
  :title="$t('chat.searchresult')"
  :visible.sync="questionopen"
  width="50%"
  :before-close="questioncon">
  <!-- <div class="mess-two" v-show="answerRecommend!=''" @click="pitchmes(gridData)" v-for="(anser,index) in answerRecommend" :key="index">
                      <div style="margin:8px" >{{anser}}</div>
                    </div> -->
  <el-scrollbar
        wrapClass="scrollbar-wrap"
        style="height:350px"
        ref="scrollbarContainer">
  <div v-for="(que,index) in questionget" :key="index">
    <span>{{que}}</span><el-button size="mini" style="margin-left:6px" @click="copyorders(que)">{{$t('chat.copy')}}</el-button>
    <!-- <div class="answerbody">
         <el-button round size="mini" @click="langeone(anser,index)">{{language}}</el-button>
          <el-button round size="mini" @click="langetwo(anser,index)">{{toLanguage}}</el-button>
    </div> -->
    
    <el-divider></el-divider>
    
  </div>
  
</el-scrollbar>
<div class="block">
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10,20, 30, 40, 50]"
      :page-size="currentPagesize4"
      layout="total, sizes, prev, pager, next, jumper"
      :total="qutotal">
    </el-pagination>
  </div>
  
  <span slot="footer" class="dialog-footer">
    <el-button @click="questionback">{{$t('chat.back')}}</el-button>
    <!-- <el-button type="primary" @click="questionopen = false">{{$t('other.a279')}}</el-button> -->
  </span>
</el-dialog>

<!-- 高频问题 -->
<el-dialog
  title="高频问题"
  :visible.sync="highstaus"
  width="50%"
  
  :before-close="highstauscolse">
  <!-- <div class="mess-two" v-show="answerRecommend!=''" @click="pitchmes(gridData)" v-for="(anser,index) in answerRecommend" :key="index">
                      <div style="margin:8px" >{{anser}}</div>
                    </div> -->
   <el-table
    :data="highData"
    height="400"
    
    style="width: 100%">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item >
            <div v-for="(item,index) in props.row.questions" :key="index">
              <span>{{ item }}</span>
            <el-button @click="copyorders(item)" size="mini" style="margin-left:20px">{{$t('chat.copy')}}</el-button>
            </div>
            
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column
      
      prop="subject">
    </el-table-column>

    <el-table-column>
      <template slot-scope="props">
        <el-button
          size="mini"
          @click="copyorders(props.row.subject)">{{$t('chat.copy')}}</el-button>
        
      </template>
    </el-table-column>
    
    
  </el-table>

<div class="block">
    
    <el-pagination
      @size-change="handleSizeChange_hi"
      @current-change="handleCurrentChange_hi"
      :current-page="currentPage"
      :page-sizes="[10,20, 30, 40, 50]"
      :page-size="currentPagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="hightital">
    </el-pagination>
  </div>
  
  <span slot="footer" class="dialog-footer">
    <el-button @click="highback">{{$t('chat.back')}}</el-button>
    <!-- <el-button type="primary" @click="questionopen = false">{{$t('other.a279')}}</el-button> -->
  </span>
</el-dialog>
<!-- 自动回复日期设置 -->
<el-dialog
  :title="$t('chat.Automaticsetting')"
  :visible.sync="response"
  width="70%"
  :before-close="Closeresponse">
   <el-checkbox v-model="monday" @change="mondayopen" border>{{$t('chat.Monday')}}</el-checkbox>
   <el-checkbox v-model="tuesday" @change="tuesdayopen" border>{{$t('chat.Tuesday')}}</el-checkbox>
   <el-checkbox v-model="wednesday" @change="wednesdayopen" border>{{$t('chat.Wednesday')}}</el-checkbox>
   <el-checkbox v-model="thursday" @change="thursdayopen" border>{{$t('chat.Thursday')}}</el-checkbox>
   <el-checkbox v-model="friday" @change="fridayopen" border>{{$t('chat.Friday')}}</el-checkbox>
   <el-checkbox v-model="saturday" @change="saturdayopen" border>{{$t('chat.Saturday')}}</el-checkbox>
   <el-checkbox v-model="sunday" @change="sundayopen" border>{{$t('chat.Sunday')}}</el-checkbox>
  <!-- <div style="margin-top: 20px">
    <el-checkbox-group v-model="checkboxGroup2" size="medium" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
    </el-checkbox-group>
  </div> -->
  <span slot="footer" class="dialog-footer">
    <el-button @click="response = false">{{$t('chat.cancel')}}</el-button>
    <el-button type="primary" @click="responsesucc">{{$t('chat.confirm')}}</el-button>
  </span>
</el-dialog>
<!-- 自动回复日期设置 -->
<el-dialog
  title="自动回复日期设置"
  :visible.sync="response"
  width="70%"
  :before-close="Closeresponse">
   <el-checkbox v-model="monday" @change="mondayopen" border>星期一</el-checkbox>
   <el-checkbox v-model="tuesday" @change="tuesdayopen" border>星期二</el-checkbox>
   <el-checkbox v-model="wednesday" @change="wednesdayopen" border>星期三</el-checkbox>
   <el-checkbox v-model="thursday" @change="thursdayopen" border>星期四</el-checkbox>
   <el-checkbox v-model="friday" @change="fridayopen" border>星期五</el-checkbox>
   <el-checkbox v-model="saturday" @change="saturdayopen" border>星期六</el-checkbox>
   <el-checkbox v-model="sunday" @change="sundayopen" border>星期日</el-checkbox>
  <!-- <div style="margin-top: 20px">
    <el-checkbox-group v-model="checkboxGroup2" size="medium" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
    </el-checkbox-group>
  </div> -->
  <span slot="footer" class="dialog-footer">
    <el-button @click="response = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="responsesucc">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
              <!-- t添加问题弹框 -->
              <el-dialog
                :title="$t('chat.CreateReply')"
                :visible.sync="issue_kj"
                width="50%"
                :show-close="false"
                :before-close="handleClose"
              >
                <el-form
                  :label-position="labelPositions"
                  label-width="80px"
                  :model="formLabelAlign"
                  size="small"
                >
                  <el-form-item :label="$t('chat.issueofstandards')">
                    <el-input v-model="formLabelAlign.name"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('chat.Similarproblems')">
                    <!-- <el-input v-model="formLabelAlign.type"></el-input> -->
                    <el-button type="primary" size="small" @click="addDomain"
                      >{{$t('chat.add')}}</el-button
                    >
                  </el-form-item>
                  <div v-if="dynamicValidateForm.domains[0]">
                    <el-form-item
                      v-for="(domain, index) in dynamicValidateForm.domains"
                      :key="domain.key"
                      :props="'domains.' + index + '.value'"
                    >
                      <el-input
                        v-model="domain.value"
                        size="small"
                        style="width: 90%"
                      ></el-input
                      ><el-button
                        @click.prevent="removeDomain(domain)"
                        size="small"
                        type="danger"
                        >{{$t('chat.delete')}}</el-button
                      >
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('chat.answer')">
                    <div style="margin-bottom: 20px">
                      <el-input
                        v-model="values"
                        size="small"
                        type="textarea"
                        :rows="4"
                      ></el-input>
                    </div>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="addknowleged_close_kj" size="small"
                    >{{$t('chat.cancel')}}</el-button
                  >
                  <el-button
                    type="primary"
                    @click="addknowleged_kj"
                    size="small"
                    >{{$t('chat.confirm')}}</el-button
                  >
                </span>
              </el-dialog>
              <!-- t添加问题弹框 -->

              <el-dialog
                :title="$t('chat.Modifytheq')"
                :visible.sync="amend_kj"
                width="50%"
                :show-close="false"
                :before-close="handleClose"
              >
                <el-form
                  :label-position="labelPositions"
                  label-width="80px"
                  :model="formLabelAlign"
                  size="small"
                >
                  <el-form-item :label="$t('chat.issue')" :required="true">
                    <el-input v-model="formLabelAlign.name"></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="分组">
                   
                    <div class="block">
                      <el-select
                        v-model="value_grop"
                        :placeholder="$t('other.a50')"
                        size="small"
                        clearable
                        @change="changevalue"
                        style="width: 100%"
                        
                      >
                        <el-option
                          v-for="item in optionso"
                          :key="item.groupId"
                          :value="item.groupName"
                        >
                        </el-option>
                      </el-select>
                     
                    </div>
                  </el-form-item> -->

                  <!-- <el-collapse v-model="collapse_name" accordion>
          <el-collapse-item title="相似问题" name="1">
            <el-input
              :v-model="hobby[index]"
              :placeholder="hobby"
              v-for="(hobby, index) in problem"
              :key="index"
              :disabled="true"
              prefix-icon="el-icon-search"
            ></el-input>
            
          </el-collapse-item>
        </el-collapse> -->
                  <el-form-item :label="$t('chat.Similarproblems')">
                    <!-- <el-input v-model="formLabelAlign.type"></el-input> -->
                    <el-button type="primary" size="small" @click="addDomain"
                      >{{$t('chat.add')}}</el-button
                    >
                  </el-form-item>
                  <div>
                    <el-form-item
                      v-for="(domain, index) in dynamicValidateForm.domains"
                      :key="index"
                    >
                      <el-input
                        v-model="domain.value"
                        size="small"
                        style="width: 90%"
                      ></el-input
                      ><el-button
                        @click.prevent="removeDomain(domain)"
                        size="small"
                        type="danger"
                        >{{$t('chat.delete')}}</el-button
                      >
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('chat.answer')">
                    <div style="margin-bottom: 20px">
                      <el-input
                        v-model="values"
                        size="small"
                        type="textarea"
                        :rows="4"
                      ></el-input>
                    </div>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="closeamend_kj" size="small">{{$t('chat.cancel')}}</el-button>
                  <el-button type="primary" @click="editknowleged_kj" size="small"
                    >{{$t('chat.confirm')}}</el-button
                  >
                </span>
              </el-dialog>
              <!-- t添加问题弹框 -->
              <!-- 输入框 -->
              <el-row style="height: 85px" class="sendMessage_ctn">
                <el-input
                @keydown.enter.native="keyDown"
                  style="border: 0;
    resize: none;"
                  v-model="textarea"
                  rows="4"
                  type="textarea"
                  @paste.native.capture.prevent="pasting($event)"
                  @blur="changblur"
                  @input="changein"
                  
                >
                </el-input>
              </el-row>
              <el-row
                style="
                  height: 45px;
                  padding-right: 0.67rem;
                  padding-bottom: 20px;
                "
                class="send"
              >
              <el-checkbox v-model="checked" style="line-height:45px;" @change="checkchang">{{$t('chat.messagetranslation')}}</el-checkbox>
              <el-select
                  v-model="voluntarily"
                  :placeholder="$t('chat.language')"
                  @change="goodsdetail_vo"
                  style="width: 5.8rem;margin-left: .3rem;"
                >
                  <el-option
                    v-for="item in goods"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-button
                  class="right"
                  type="primary"
                  @click="send()"
                  :disabled="textarea == ''"
                  >{{$t('chat.send')}}</el-button
                >

                <!-- <el-dropdown class="right"> -->
                <!-- <span class="el-dropdown-link"> -->
                <el-button
                  v-show="btn_fy == '1'"
                  type="primary"
                  style="margin-right: 20px"
                  :disabled="textarea == ''"
                  @click="translate"
                  class="right"
                  >{{$t('chat.translate')}}</el-button
                >
                <el-button
                  v-show="btn_fy == '2'"
                  type="primary"
                  style="margin-right: 20px"
                  :disabled="textarea == ''"
                  @click="translates"
                  class="right"
                  >{{$t('chat.original')}}</el-button
                >
                <el-select
                  v-model="languages"
                  :placeholder="$t('chat.language')"
                  @change="goodsdetail()"
                  class="righti"
                >
                  <el-option
                    v-for="item in goods"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- </span> -->
                <!-- <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="sendTranslate('en')"
                      v-if="toLanguage != 'en'"
                      :disabled="textarea == ''"
                      >翻译为英文</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="sendTranslate('th')"
                      v-if="toLanguage != 'th'"
                      :disabled="textarea == ''"
                      >翻译为泰文</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="sendTranslate('ms')"
                      v-if="toLanguage != 'ms'"
                      :disabled="textarea == ''"
                      >翻译为马来文</el-dropdown-item
                    >
                    <el-dropdown-item
                      @click.native="sendTranslate('')"
                      v-if="toLanguage != ''"
                      :disabled="textarea == ''"
                      >显示原文</el-dropdown-item
                    >
                  </el-dropdown-menu> -->
                <!-- </el-dropdown> -->
              </el-row>
            </el-footer>
          </el-container>
        </el-container>
      </el-col>

      <!-- 右侧 -->
      <el-col :span="8" style="height:100%;">
        <el-row >
          <!-- <el-menu :default-active="activeIndex"  class="el-menu-demo" mode="horizontal"  >
                <el-menu-item index="1">订单数据</el-menu-item>
                <el-menu-item index="2">用户画像</el-menu-item>
              </el-menu> -->
          <el-tabs v-model="activeIndex" style="height: 37.5rem">
            <el-tab-pane :label="$t('chat.Orderdata')" name="first" >
              <!-- <div v-if="this.result == false" class="order_dd_body">
                <el-alert
                title="想查看买家订单 需要二次授权'订单接口'权限，请授权"
                type="warning"
                effect="dark">
              </el-alert>
                   <el-button type="warning" @click="openAuthorization" style="margin-top:100px">授权Shopee订单</el-button>
              </div> -->
              <!-- <div v-if="this.result == true" class="order_dd_body">              -->
              <div
                style="height: 36.5rem; overflow: auto"
                v-loading="orderLoading"
                v-if="orderData != ''"
              >
                <el-row
                  class="center top"
                  v-for="(item, index) in orderData"
                  :key="index"
                >
                  <el-card class="box-card" style="width: 25rem">
                    <div slot="header" class="clearfix">
                      <el-row>
                        <el-col :span="8" style="font-size: 14px">
                          <b style="color: #606266">{{
                            translateData[item.order_status]
                          }}</b>
                        </el-col>
                        <el-col :span="16" class="right">
                          <span class="right" style="font-size: 12px">{{
                            stringTime(item.create_time)
                          }}</span>
                        </el-col>
                      </el-row>
                      <el-row style="font-size: 12px">
                        <pre>{{$t('homeTwo.SubInspection')}}:{{ item.order_sn }}<i class="el-icon-copy-document" @click="copyorder(item.order_sn)" style="cursor:pointer;color: #409eff"></i></pre>
                      </el-row>
                    </div>

                    <div style="border-bottom: 2px #f4f4f4 solid">
                      <el-row v-for="(item_, index_) in item.item_list">
                        <el-col :span="4" class="center">
                          <el-image
                            :src="item_.detail[0].image.image_url_list[0]"
                            fit="fill"
                            style="width: 4rem; height: 4rem;"
                          ></el-image>
                        </el-col>
                        <el-col :span="20" style="padding-left: 0.67rem">
                          <el-row>
                            <el-col
                              :span="20"
                              style="
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                                font-size: 12px;
                              "
                            >
                              <a
                                style="color: #409eff"
                                :href="
                                  'https://th.xiapibuy.com/product/' +
                                  shopId +
                                  '/' +
                                  item_.item_id
                                "
                                target="view_window"
                                >{{ item_.item_name }}</a
                              >
                            </el-col>
                            <el-col :span="4">
                              <!-- 商品的单价（初始价格可以取到但一般是算上折扣的，两者相差较大，就暂时先不加上去） -->
                              <span class="right" style="font-size: 12px"
                                >฿{{
                                  item_.model_discounted_price == 0
                                    ? "--"
                                    : item_.model_discounted_price
                                }}</span
                              >
                            </el-col>
                          </el-row>
                          <el-row style="margin-top: 5px">
                            <el-col
                              :span="20"
                              style="font-size: 12px; height: 1px"
                            >
                              {{ item_.model_name }}
                            </el-col>
                            <el-col :span="4">
                              <span class="right" style="font-size: 12px">
                                x{{ item_.model_quantity_purchased }}
                              </span>
                            </el-col>
                          </el-row>
                          <el-row style="font-size: 12px; margin-top: 5px">
                            Parent SKU:{{ item_.item_sku
                            }}<i
                              class="el-icon-copy-document"
                              @click="copyorder(item_.item_sku)"
                              style="cursor: pointer; color: #409eff"
                            ></i>
                          </el-row>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="border-bottom: 2px #f4f4f4 solid">
                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="
                          item.order_status == 'COMPLETED' ||
                          item.order_status == 'SHIPPED' ||
                          item.order_status == 'READY_TO_SHIP' ||
                          item.order_status == 'REFUND' ||
                          item.order_status == 'TO_CONFIRM_RECEIVE' ||
                          item.order_status == 'PROCESSED' ||
                          item.order_status == 'IN_CANCEL' ||
                          item.order_status == 'CANCELLED'
                        "
                      >
                        <el-col :span="12" style="font-size: 14px">
                          {{$t('homeTwo.Totalpayment')}}
                        </el-col>
                        <el-col :span="12">
                          <span class="right" style="font-size: 12px"
                            >{{item.region == 'TH'?'฿':'' || item.region == 'MY'?'RM':'' || item.region == 'PH'?'P':'' || item.region == 'ID'?'RP':'' || item.region == 'VN'?'VND':''}}{{ item.total_amount }}</span
                          >
                        </el-col>
                      </el-row>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="
                          item.order_status == 'COMPLETED' ||
                          item.order_status == 'SHIPPED' ||
                          item.order_status == 'READY_TO_SHIP' ||
                          item.order_status == 'REFUND' ||
                          item.order_status == 'TO_CONFIRM_RECEIVE' ||
                          item.order_status == 'PROCESSED' ||
                          item.order_status == 'IN_CANCEL' ||
                          item.order_status == 'CANCELLED'
                        "
                      >
                        <el-col :span="12" style="font-size: 14px">
                          {{$t('homeTwo.Paymenttime')}}
                        </el-col>
                        <el-col :span="12">
                          <span class="right" style="font-size: 12px">{{
                              item.pay_time==null? $t('chat.uNPAID') : stringTime(item.pay_time)
                          }}</span>
                        </el-col>
                      </el-row>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="
                          item.order_status == 'COMPLETED' ||
                          item.order_status == 'SHIPPED' ||
                          item.order_status == 'READY_TO_SHIP' ||
                          item.order_status == 'REFUND' ||
                          item.order_status == 'TO_CONFIRM_RECEIVE' ||
                          item.order_status == 'PROCESSED' 
                          
                        "
                      >
                        <el-col :span="6">
                          <span style="font-size: 14px"> {{$t('homeTwo.Logisticsinformation')}} </span>
                        </el-col>
                        <el-col :span="18">
                          <span>
                            <el-popover
                              placement="left-end"
                              width="300"
                              trigger="hover"
                              class="right"
                              style="font-size: 1rem"
                            >
                              <el-steps
                                direction="vertical"
                                :active="1"
                                style="font-size: 12px"
                                space="3rem"
                              >
                                <el-step
                                  :title="$t('chat.stepone')"
                                  v-for="(item_1, index1) in item.logisticDetail
                                    .tracking_info"
                                  :key="index1"
                                >
                                  <template slot="title">
                                    <span style="font-size: 12px">
                                      {{ item_1.description }}</span
                                    >
                                  </template>
                                  <template slot="description">
                                    <span style="font-size: 12px">
                                      {{ stringTime(item_1.update_time) }}
                                    </span>
                                  </template>
                                </el-step>
                              </el-steps>
                              <!-- <el-button slot="reference" size="mini" class="el-icon-warning-outline">{{$t('other.a82')}}</el-button> -->
                              <span slot="reference" style="color: #409eff;font-size:10px;margin-left:5px;cursor: pointer;">查看</span>
                              <!-- <i
                                class="el-icon-warning-outline"
                                style="color: #409eff"
                                slot="reference"
                              ></i> -->
                            </el-popover>
                          </span>
                          <span class="right" style="font-size: 12px">{{
                            item.shipping_carrier
                          }}</span>
                        </el-col>
                      </el-row>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="item.order_status == 'COMPLETED'"
                      >
                        <el-col :span="10">
                          <span style="font-size: 14px">  {{$t('homeTwo.Completetime')}} </span>
                        </el-col>
                        <el-col :span="14">
                          <span class="right" style="font-size: 12px">{{
                            stringTime(item.update_time)
                          }}</span>
                        </el-col>
                      </el-row>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="
                          item.order_status == 'READY_TO_SHIP' ||
                          item.order_status == 'TO_CONFIRM_RECEIVE' ||
                          item.order_status == 'PROCESSED'
                        "
                      >
                        <el-col :span="10">
                          <span style="font-size: 14px"> {{$t('chat.DatetoPull')}} </span>
                        </el-col>
                        <el-col :span="14">
                          <span class="right" style="font-size: 12px">{{
                            stringTime(item.ship_by_date)
                          }}</span>
                        </el-col>
                      </el-row>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="
                          item.order_status == 'COMPLETED' ||
                          item.order_status == 'SHIPPED' ||
                          item.order_status == 'READY_TO_SHIP' ||
                          item.order_status == 'REFUND' ||
                          item.order_status == 'TO_CONFIRM_RECEIVE' ||
                          item.order_status == 'PROCESSED' ||
                          item.order_status == 'UNPAID' ||
                          item.order_status == 'IN_CANCEL' ||
                          item.order_status == 'CANCELLED' ||
                          item.order_status == 'TO_RETURN' 
                        "
                      >
                        <el-col :span="10">
                          <span style="font-size: 14px"> {{$t('homeTwo.Addnotes')}} </span>
                        </el-col>
                        <el-col :span="14">
                          <span
                            class="right"
                            style="color: #409eff; cursor: pointer"
                            @click="openremark(item)"
                            v-show="item.note == '' || item.note == ' '"
                            ><i
                              class="el-icon-circle-plus"
                              style="color: #409eff"
                            ></i
                            >{{$t('homeTwo.Remarks')}}</span
                          >
                          <span
                            class="right"
                            style="color: #409eff; cursor: pointer"
                            @click="openremark_xg(item)"
                            v-show="item.note != '' && item.note != ' '"
                            ><i class="el-icon-edit" style="color: #409eff"></i
                            >{{$t('chat.modification')}}</span
                          >
                        </el-col>
                        <el-dialog
                          :title="$t('homeTwo.Remarks')"
                          :visible.sync="remarks"
                          width="30%"
                          :before-close="handleClose"
                        >
                          <el-input
                            type="textarea"
                            :placeholder="$t('chat.entercontent')"
                            v-model="remark"
                            
                            show-word-limit
                            :rows="5"
                          >
                          </el-input>
                          <span slot="footer" class="dialog-footer">
                            <el-button @click="closeremarks">{{$t('chat.cancel')}}</el-button>
                            <el-button
                              type="primary"
                              @click="suceedremarks(item)"
                              >{{$t('chat.confirm')}}</el-button
                            >
                          </span>
                        </el-dialog>
                      </el-row>
                      <div class="beizhu" v-show="item.note != '' && item.note != ' ' && item.note != null">
                        {{ item.note }}
                      </div>

                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="item.order_status == 'CANCELLED' || item.order_status == 'IN_CANCEL'"
                      >
                        <el-row>
                          <el-col :span="10">
                            <span style="font-size: 14px"> {{$t('homeTwo.Canceldetails')}} </span>
                          </el-col>
                          <el-col :span="14">
                            <span class="right" style="font-size: 12px"
                              >Cancel by {{ item.cancel_by }}</span
                            >
                          </el-col>
                        </el-row>
                        <el-row>
                          <div style="background: #f7f8fb">
                            <span style="font-size: 12px">{{
                              item.buyer_cancel_reason == ""
                                ? "Unknown reason"
                                : item.buyer_cancel_reason
                            }}</span>
                          </div>
                        </el-row>
                      </el-row>
                      <el-row
                        style="padding: 0.67rem 0px 0.67rem 0px"
                        v-if="item.order_status == 'CANCELLED' || item.order_status == 'IN_CANCEL'"
                      >
                        <el-col :span="10">
                          <span style="font-size: 14px"> {{$t('problemorder.cancel_time')}} </span>
                        </el-col>
                        <el-col :span="14">
                          <span class="right" style="font-size: 12px">{{
                            stringTime(item.update_time)
                          }}</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div>
                      <el-button
                        type="primary"
                        size="small"
                        class="right"
                        @click="Sendgoods(item)"
                        >{{$t('chat.send')}}</el-button
                      >
                    </div>
                    <div
                      v-if="
                        item.order_status == 'SHIPPED' ||
                        item.order_status == 'READY_TO_SHIP' ||
                        item.order_status == 'RETRY_SHIP' ||
                        item.order_status == 'UNPAID'
                      "
                    >
                      <el-button
                        type="danger"
                        size="small"
                        class="right_b"
                        @click="closetable(item)"
                        >{{$t('chat.cancellationorder')}}</el-button
                      >
                      <el-dialog
                        :title="$t('chat.cause')"
                        :visible.sync="closecau"
                        width="30%"
                        :before-close="handleClose"
                      >
                        <el-select
                          v-model="causes"
                          :placeholder="$t('chat.cause')"
                          @change="checkcausers()"
                          class="center"
                        >
                          <el-option
                            v-for="item in cause"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="closecau = false">{{$t('chat.cancel')}}</el-button>
                          <el-button type="primary" @click="cancelorder(item)"
                            >{{$t('chat.confirm')}}</el-button
                          >
                        </span>
                      </el-dialog>
                    </div>
                  </el-card>
                </el-row>
              </div>
              <div
                style="height: 36.5rem; overflow: auto"
                v-loading="orderLoading"
                v-if="orderData == ''"
                class="order_dd"
              >
                <div class="order_dd_body">
                  <div><img src="../../assets/img/cjwt@2x.png" alt="" style="witdh:100px;height:200px"></div>
                  <div class="order_dd_body_text">{{$t('chat.Nouser')}}</div>
                </div>
              </div>
              <!-- </div> -->
             
            </el-tab-pane>
            <el-tab-pane :label="$t('homeTwo.Userportrait')" name="second">
              
              <div v-if="this.result == false" class="order_dd_body">
                <el-alert
                title="想查看买家订单 需要二次授权'订单接口'权限，请授权"
                type="warning"
                effect="dark">
              </el-alert>
                   <el-button type="warning" @click="openAuthorization" style="margin-top:100px">授权Shopee订单</el-button>
              </div>
              <div v-if="this.result == true" class="order_dd_body">
              <div v-show="buyerUser == null"  class="order_dd" style="height: 36.5rem; overflow: auto">
               <div class="order_dd_body">
                  <div><img src="../../assets/img/cjwt@2x.png" alt="" style="witdh:100px;height:200px"></div>
                  <div class="order_dd_body_text">{{$t('chat.Nouserportrai')}}</div>
                </div>
              </div>
              <div
                style="
                  height: 18rem;
                  width: 26rem;
                  border: 1px solid #d1e0e0;
                  border-radius: 5px;
                  padding: 0.3rem;
                "
                v-show="buyerUser != null"
                id="categoryPortraitEchart"
              ></div>
              <div>
                <ul class="first_wrapper">
                  <li class="first_category" v-if="buyerUser != null">
                    <div class="item_category">
                      {{$t('chat.category')}}:{{ category_user.category_cn }}
                    </div>
                    <div class="item_category">
                      {{$t('chat.powerofconsumption')}}：{{
                        tble_user[buyerUser.consumptionLevel]
                      }}
                    </div>
                    <div class="item_category">
                      {{$t('chat.Totalconsumption')}}：{{this.country == 'TH'?'฿':'' || this.country == 'MY'?'RM':'' || this.country == 'PH'?'P':'' || this.country == 'ID'?'RP':'' || this.country == 'VN'?'VND':''}}{{ buyerUser.priceSumDecimal }}
                    </div>
                    <div class="item_category">
                      <!-- 忠诚度：{{table_translation[buyerUser.loyaltyLevels]}} -->
                      <div>{{$t('chat.Loyalty')}}：</div>
                      <div>
                        <el-rate
                          v-model="user_hj"
                          disabled
                          show-score
                          text-color="#ff9900"
                          :max=4
                        >
                        </el-rate>
                       
                      </div>
                    </div>
                    <div class="item_category">
                      {{$t('chat.Numbeconsumption')}}：{{ buyerUser.orderNumDecimal }}
                    </div>
                    <div class="item_category">
                      {{$t('chat.rejectedorders')}}：{{ buyerUser.rejectionNumDecimal }}
                    </div>
                    <div class="item_category">
                      {{$t('chat.consumptioninterval')}}：{{ buyerUser.intervalMeanDecimal }}{{$t('chat.day')}}
                    </div>

                    <div class="item_category">
                      {{$t('chat.Consumptioratio')}}：{{ buyerUser.premiumMeanDecimal }}%
                    </div>
                    <div class="item_category">
                      {{$t('chat.Lastdate')}}：{{ buyerUser.lastOrderDecimal }}{{$t('chat.day')}}
                    </div>
                  </li>
                </ul>
              </div>
              </div>
              <!-- <el-col :span="10">
        <ul class="first_wrapper">
          <li class="first_category" v-if="categoryPortrait != null">
            <div class="item_category">
              {{$t('other.a1943')}}：{{ categoryPortrait.category_cn }}
            </div>
            <div class="item_category">
              {{$t('other.a1997')}}：{{ categoryPortrait.intervalMeanAvg }}天
            </div>
            <div class="item_category">
              {{$t('other.a1998')}}：{{ categoryPortrait.orderNumAvg }}
            </div>
            <div class="item_category">
              {{$t('other.a1999')}}：{{ categoryPortrait.lastOrderAvg }}天
            </div>
            <div class="item_category">
              {{$t('other.a2000')}}：{{ categoryPortrait.premiumMeanAvg }}%
            </div>
            <div class="item_category">
              {{$t('other.a2001')}}：{{ categoryPortrait.priceSumAvg }}฿
            </div>
            <div class="item_category">
              {{$t('other.a2002')}}：{{ categoryPortrait.rejectionNumAvg }}
            </div>
          </li>
        </ul>
      </el-col> -->
            </el-tab-pane>
            <el-tab-pane :label="$t('chat.Qamanagement')" name="third">
              <el-form
                :inline="true"
                :model="formInline"
                class="demo-form-inline"
                :label-position="labelPosition"
                label-width="80px"
              >
                <el-form-item :label="$t('chat.Selectgroup')">
                  <el-select
                    v-model="value_grop_so"
                    :placeholder="$t('allorders.pleasechoose')"
                    size="small"
                    clearable
                    @change="changevalue"
                  >
                    <el-option
                      v-for="item in optionso"
                      :key="item.groupId"
                      :label="item.groupName"
                      :value="item.groupId"
                    >
                    </el-option>
                  </el-select>
                  <!-- <el-cascader
                    v-model="value"
                    :options="optionso"
                    @change="handleChange"
                    clearable
                    size="small"
                  ></el-cascader> -->
                </el-form-item>
                <el-form-item :label="$t('chat.questions')">
                  <el-input
                    v-model="input"
                    :placeholder="$t('chat.searchquestion')"
                    clearable
                    size="small"
                  ></el-input>
                </el-form-item>

                <el-form-item :label="$t('chat.operationexecutive')">
                  <el-button type="primary" size="small" @click="searchknow"
                    >{{$t('chat.search')}}</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click="classify = true"
                    >{{$t('chat.groupingmanagement')}}</el-button
                  >
                  <!-- <el-button type="primary" size="small" @click="issue = true"
                    >添加问答</el-button
                  > -->
                </el-form-item>
              </el-form>
              <!-- 分类管理弹窗 -->
              <el-dialog
                :title="$t('chat.groupingmanagement')"
                :visible.sync="classify"
                width="50%"
                :before-close="handleClose"
              >
                <div>
                  <el-button size="small" @click="appendfirst" type="primary"
                    >{{$t('chat.Thenewgrouping')}}</el-button
                  >
                </div>
                <el-table :data="optionso" style="width: 100%">
                  <el-table-column :label="$t('chat.grouping')" width="280" prop="groupName">
                  </el-table-column>

                  <el-table-column :label="$t('chat.operationexecutive')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)"
                        >{{$t('chat.compile')}}</el-button
                      >
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)"
                        >{{$t('chat.delete')}}</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="handleAdd(scope.$index, scope.row)"
                        >{{$t('chat.Addanswer')}}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="custom-tree-container">
                  <el-tree
                    class="treeitems"
                    :data="optionso"
                    node-key="groupId"
                    @node-click="handleNodeClick"
                    ref="tree"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ optionso.groupName }}</span>
                      <span>
                        <el-button
                          type="text"
                          size="mini"
                          @click="() => append(node, data)"
                        >
                          添加
                        </el-button>
                        <el-button
                          type="text"
                          size="mini"
                          @click="() => deletes(node, data)"
                        >
                          {{$t('other.a312')}}
                        </el-button>
                        <el-button
                          type="text"
                          size="mini"
                          @click="() => rename(node, data)"
                        >
                          修改
                        </el-button>
                      </span>
                    </span>
                  </el-tree>
                </div> -->
              </el-dialog>
              <!-- 分类管理弹窗 -->
              <!-- 添加子节点节点弹窗 -->

              <el-dialog
                :title="$t('chat.groupname')"
                :visible.sync="node_son"
                width="30%"
                :before-close="handleClose"
              >
                <el-input
                  :placeholder="$t('chat.entercontent')"
                  v-model="input_node_son"
                  clearable
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="node_son = false">{{$t('chat.cancel')}}</el-button>
                  <el-button type="primary" @click="node_add_son"
                    >{{$t('chat.confirm')}}</el-button
                  >
                </span>
              </el-dialog>

              <!-- 添加根节点弹窗 -->
              <!-- 添加根节点弹窗 -->

              <el-dialog
                :title="$t('chat.groupname')"
                :visible.sync="dialogVisible_node"
                width="30%"
                :before-close="handleClose"
              >
                <el-input
                  :placeholder="$t('chat.entercontent')"
                  v-model="input_node"
                  clearable
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible_node = false"
                    >{{$t('chat.cancel')}}</el-button
                  >
                  <el-button type="primary" @click="node_add">{{$t('chat.confirm')}}</el-button>
                </span>
              </el-dialog>

              <!-- 添加根节点弹窗 -->
              <!-- 修改根节点弹窗 -->
              <el-dialog
                :title="$t('chat.cancel')"
                :visible.sync="modify"
                width="30%"
                :before-close="handleClose"
              >
                <el-input
                  :placeholder="$t('chat.entercontent')"
                  v-model="input_node_modify"
                  clearable
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="modify = false">{{$t('chat.cancel')}}</el-button>
                  <el-button type="primary" @click="modify_node_add"
                    >{{$t('chat.confirm')}}</el-button
                  >
                </span>
              </el-dialog>
              <!-- 修改根节点弹窗 -->
              <!-- t添加问题弹框 -->
              <el-dialog
                :title="$t('chat.Thenewanswers')"
                :visible.sync="issue"
                width="50%"
                :show-close="false"
                :before-close="handleClose"
              >
                        <el-input
                        style="width:60%"
            :placeholder="$t('chat.enterthekeyword')"
            v-model="qestionvalue"
            size="small"
            clearable>
          </el-input>
          <el-button type="primary" @click="searchqestion" size="small">{{$t('chat.search')}}</el-button>
          <el-button type="primary" @click="highfrequency" size="small">高频问题</el-button>
                <el-form
                  :label-position="labelPositions"
                  label-width="80px"
                  :model="formLabelAlign"
                  size="small"
                >
                  <el-form-item :label="$t('chat.issueofstandards')" :required="true">
                    <el-dropdown @command="handleCommand_fy">
  <span class="el-dropdown-link" style=" color: #409eff">
    {{$t('chat.translate')}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="a">{{$t('chat.English')}}</el-dropdown-item>
    <el-dropdown-item command="b">{{$t('chat.Thai')}}</el-dropdown-item>
    <el-dropdown-item command="c">{{$t('chat.Malay')}}</el-dropdown-item>
    
  </el-dropdown-menu>
</el-dropdown>
                    <el-input v-model="formLabelAlign.name"></el-input>
                    
                  </el-form-item>
                  <!-- <el-form-item label="当前分组">
                   
                    <div class="block">
                      <el-select
                        v-model="value_grop"
                        :placeholder="$t('other.a50')"
                        size="small"
                        clearable
                        @change="changevalue"
                        style="width: 100%"
                        disabled
                      >
                        <el-option
                          v-for="item in optionso"
                          :key="item.groupId"
                          :value="item.groupName"
                        >
                        </el-option>
                      </el-select>
                      
                    </div>
                  </el-form-item> -->
                  <el-form-item :label="$t('chat.Similarproblems')">
                    <!-- <el-input v-model="formLabelAlign.type"></el-input> -->
                    <el-button type="primary" size="small" @click="addDomain"
                      >{{$t('chat.add')}}</el-button
                    >
                    <el-select v-model="command_value" :placeholder="$t('chat.language')" style="width:80px" @change="checkcommond">
                    <el-option
                      v-for="item in companyList"  
                      :key="item.id"
                      :label="item.user_name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  </el-form-item>
                  <div v-if="dynamicValidateForm.domains[0]">
                    <el-form-item
                      v-for="(domain, index) in dynamicValidateForm.domains"
                      :key="domain.key"
                      :props="'domains.' + index + '.value'"
                    >
                      <el-input
                        v-model="domain.value"
                        size="small"
                        style="width: 80%"
                      ></el-input
                      ><el-button
                        @click.prevent="removeDomain(domain)"
                        size="small"
                        type="danger"
                        >{{$t('chat.add')}}</el-button
                      >
                      <el-button
                        @click.prevent="handleCommand_xs(domain)"
                        size="small"
                        type="primary"
                        >{{$t('chat.translate')}}</el-button
                      >
                      <!-- <el-dropdown @command="handleCommand_xs(domain)">
  <span class="el-dropdown-link" style=" color: #409eff">
    翻译<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item  v-for="item in companyList" :key="item.id" :command="item.id">{{item.user_name}}</el-dropdown-item>
    
    
  </el-dropdown-menu>
</el-dropdown> -->

                    </el-form-item>
                    
                  </div>
                  <el-form-item :label="$t('chat.answer')">
                     <el-dropdown @command="handleCommand_da">
  <span class="el-dropdown-link" style=" color: #409eff">
    {{$t('chat.translate')}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item command="1">{{$t('chat.English')}}</el-dropdown-item>
    <el-dropdown-item command="2">{{$t('chat.Thai')}}</el-dropdown-item>
    <el-dropdown-item command="3">{{$t('chat.Malay')}}</el-dropdown-item>
    
  </el-dropdown-menu>
</el-dropdown>
                    <div style="margin-bottom: 20px">
                      <el-input
                        v-model="values"
                        size="small"
                        type="textarea"
                        :rows="4"
                      ></el-input>
                    </div>
                   
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="addknowleged_close" size="small"
                    >{{$t('chat.cancel')}}</el-button
                  >
                  <el-button type="primary" @click="addknowleged" size="small"
                    >{{$t('chat.confirm')}}</el-button
                  >
                </span>
              </el-dialog>
              
              <!-- t添加问题弹框 -->
              <!-- t添加问题弹框 -->

              <el-tabs
                type="border-card"
                style="width: 420px"
                v-model="tabName"
                @tab-click="tabclick()"
              >
                <el-tab-pane
                  :key="item.groupId"
                  v-for="(item, index) in optionso"
                  :label="item.groupName"
                  :name="item.groupId"
                >
                  <el-table :data="tableData" height="340" border>
                    <el-table-column
                      prop="question"
                      :label="$t('chat.issueofstandards')"
                      width="100"
                    >
                    <template slot-scope="scope">
                      <el-popover @show="contentDetail(scope.$index, scope.row)" trigger="hover" placement="top-start">
                        <div slot="reference">
                              <span>{{ scope.row.question }}</span>
                        </div>
                        <div>
                        <p style="color:#409eff">{{$t('chat.Similarproblems')}}:</p>
                        <div v-for="(answer,index) in answers" :key="index" class="pover">
                            
                            <div class="pover_body">{{answer.value}}</div>
                        </div>
                        </div>    
                      </el-popover>
                      

                    </template>
                    </el-table-column>
                    <el-table-column prop="answer" :label="$t('chat.revert')" width="120">
                    </el-table-column>

                    <el-table-column :label="$t('chat.operationexecutive')">
                      <template slot-scope="scope" width="280">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="amendEdit(scope.$index, scope.row)"
                          >{{$t('chat.modification')}}</el-button
                        >
                        <el-button
                          size="mini"
                          type="danger"
                          @click="handleDel(scope.$index, scope.row)"
                          >{{$t('chat.delete')}}</el-button
                        >
                        <!-- <el-button
                          size="mini"
                          @click="handleEdit(scope.$index, scope.row)"
                          >查看</el-button
                        > -->
                      </template>
                    </el-table-column>
                  </el-table>
                  <div>
                    <el-button @click="addnew" type="primary" size="small"
                      >{{$t('chat.thecurrentgroup')}}</el-button
                    >
                  </div>
                </el-tab-pane>
              </el-tabs>
              <!-- <el-table :data="tableData" style="width: 100%">
                <el-table-column label="问答" width="180">
                  <div>
                    <div>阿斯顿</div>
                    <div>所属分组：创建账号</div>
                  </div>
                  
                </el-table-column>
                <el-table-column label="是否启用" width="80">
                  <template scope="scope">
                    <el-switch
                      active-color="#5B7BFA"
                      inactive-color="#dadde5"
                      v-model="scope.row.menusstate"
                      @change="change(scope.$index, scope.row)"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('other.a33')">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)"
                      >{{$t('other.a238')}}</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)"
                      >{{$t('other.a312')}}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table> -->
            </el-tab-pane>
          </el-tabs>
          <!-- 问答库表格 -->

          <!-- 用户画像（数据还没给） -->
          <!-- <el-row style="margin-top:30px">
              <div ref="echart1" style="height:400px;width:400px" class="center" v-if="activeIndex=='1'">
                <p style="font-size:20px;color:#606266">暂无数据</p>
              </div>  
              <el-row v-else-if="activeIndex=='3'">
                <div
                  id="lumenChatPanel"
                  class="talks-container lum-scrollbar scrollbar"
                  @scroll="talkPanelScroll($event)"
                  style="height:520px;"
                >
                <el-scrollbar style="height:100%" id="chatHistory">
                  <div ref="chat" v-for="item,index in conversationHistory" :key="conversationHistory[index].content+index" v-if="tab" >
                    <el-row class="top" v-if="conversationData.toId!=item.fromId&&item.messageType=='text'">
                        <el-col :span="22">
                        <el-dropdown trigger="click" class="right top">
                          <span class="el-dropdown-link">
                            <text-message
                                :content="item.content"
                                float="right"
                                :full-width="true"
                                :arrow="true"
                            />
                            <el-row>
                              <span class="right" style="font-size:12px;color:#606266">{{item.time}}</span>
                            </el-row>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'en')">翻译为英语</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'zh-CHS')">翻译为中文</el-dropdown-item>
                            <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'')" v-if="item.content_!=undefined">显示原文</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>

                        </el-col>
                        <el-col :span="2" class="center" style="padding-left:1rem">
                            <i class="iconfont icon-kefucopy" style="font-size: 28px;color: orange;" ></i>
                        </el-col>
                    </el-row>
                    <el-row class="top" v-else-if="conversationData.toId!=item.fromId&&item.messageType=='image'">
                        <el-col :span="22" style="height:200px">
                          <el-row>
                            <image-message
                              :src="item.content"
                              class="right"
                            />
                          </el-row>

                            <el-row>
                              <span class="right" style="font-size:12px;color:#606266">{{item.time}}</span>
                            </el-row>
                        </el-col>
                        <el-col :span="2" class="center" style="padding-left:1rem">
                            <i class="iconfont icon-kefucopy" style="font-size: 28px;color: orange;" ></i>
                        </el-col>
                    </el-row>
                    <el-row class="top" v-else-if="conversationData.toId==item.fromId&&item.messageType=='text'">
                        <el-col :span="3" class="center" style="padding-right:1rem">
                          <el-image v-if="toAvatar!=''" style="width:35px;height:35px;border-radius:50%" :src="toAvatar" fit="fill"></el-image>
                          <i v-else class="iconfont icon-kehuAx" style="font-size: 28px;color: #409eff;"></i>
                        </el-col>                                
                        <el-col :span="21">
                          <el-dropdown trigger="click">
                            <span class="el-dropdown-link">
                              <text-message
                                  :content="item.content"
                                  float="left"
                                  :full-width="true"
                                  :arrow="true"
                              />
                              <el-row>
                                <span span class="left" style="font-size:12px;color:#606266">{{item.time}}</span>
                              </el-row>
                          
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'en')">翻译为英语</el-dropdown-item>
                              <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'zh-CHS')">翻译为中文</el-dropdown-item>
                              <el-dropdown-item icon="el-icon-plus" @click.native="translation(item,index,'')" v-if="item.content_!=undefined">显示原文</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>

                        </el-col>
                    </el-row>
                    <el-row class="top" style="margin-bottom:20px" v-else-if="conversationData.toId==item.fromId&&item.messageType=='image'">
                        <el-col :span="2" class="center" style="padding-left:1rem">
                            <el-image v-if="toAvatar!=''" style="width:35px;height:35px;border-radius:50%" :src="toAvatar" fit="fill"></el-image>
                            <i v-else class="iconfont icon-kehuAx" style="font-size: 28px;color: #409eff;"></i>
                        </el-col>      
                        <el-col :span="22" style="height:200px;padding-left:20px">
                          <image-message
                            :src="item.content"
                          />
                            <el-row>
                              <span class="left" style="font-size:12px;color:#606266">{{item.time}}</span>
                            </el-row>
                        </el-col>
                    </el-row>
                  </div>
                </el-scrollbar>
                </div>          
              </el-row>


            </el-row> -->
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="$t('chat.Modifytheq')"
      :visible.sync="amend"
      width="50%"
      :show-close="false"
      :before-close="handleClose"
    >
      <el-form
        :label-position="labelPositions"
        label-width="80px"
        :model="formLabelAlign"
        size="small"
      >
        <el-form-item :label="$t('chat.issue')" :required="true">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="分组">
                   
                    <div class="block">
                      <el-select
                        v-model="value_grop"
                        :placeholder="$t('other.a50')"
                        size="small"
                        clearable
                        @change="changevalue"
                        style="width: 100%"
                        
                      >
                        <el-option
                          v-for="item in optionso"
                          :key="item.groupId"
                          :value="item.groupName"
                        >
                        </el-option>
                      </el-select>
                     
                    </div>
                  </el-form-item> -->

        <!-- <el-collapse v-model="collapse_name" accordion>
          <el-collapse-item title="相似问题" name="1">
            <el-input
              :v-model="hobby[index]"
              :placeholder="hobby"
              v-for="(hobby, index) in problem"
              :key="index"
              :disabled="true"
              prefix-icon="el-icon-search"
            ></el-input>
            
          </el-collapse-item>
        </el-collapse> -->
        <el-form-item :label="$t('chat.Similarproblems')">
          <!-- <el-input v-model="formLabelAlign.type"></el-input> -->
          <el-button type="primary" size="small" @click="addDomain"
            >{{$t('chat.add')}}</el-button
          >
        </el-form-item>
        <div>
          <el-form-item
            v-for="(domain, index) in dynamicValidateForm.domains"
            :key="index"
          >
            <el-input
              v-model="domain.value"
              size="small"
              style="width: 90%"
            ></el-input
            ><el-button
              @click.prevent="removeDomain(domain)"
              size="small"
              type="danger"
              >{{$t('chat.delete')}}</el-button
            >
          </el-form-item>
        </div>
        <el-form-item :label="$t('chat.answer')">
          <div style="margin-bottom: 20px">
            <el-input
              v-model="values"
              size="small"
              type="textarea"
              :rows="4"
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeamend" size="small">{{$t('chat.cancel')}}</el-button>
        <el-button type="primary" @click="editknowleged" size="small"
          >{{$t('chat.confirm')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- t添加问题弹框 -->
    <!-- 添加新的自定义分组 -->
    <el-dialog
        :title="$t('chat.Addanewcustomgroup')"
        :visible.sync="addnewgrop"
        width="50%"
        :before-close="handleClose_grop">
        <el-form :model="ruleForm"  ref="ruleForm" label-width="100px"  :label-position="labelPosition">
            <el-form-item :label="$t('homeTwo.GroupName')"  :required="true">
              <el-input type="text" v-model="ruleForm.pass"></el-input>
            </el-form-item>
            <el-form-item :label="$t('homeTwo.Groupdescription')" >
              <el-input type="textarea" v-model="ruleForm.checkPass" :rows=5></el-input>
            </el-form-item>
            
          </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addnewgropcos">{{$t('chat.cancel')}}</el-button>
          <el-button type="primary" @click="addnewgropcli">{{$t('chat.confirm')}}</el-button>
        </span>
      </el-dialog>

    <!-- 添加新的自定义分组 -->
    <!-- 添加买家到分组 -->
    <el-dialog
        :title="$t('chat.Addtogroup')"
        :visible.sync="custom_hint"
        width="50%"
        :before-close="handleClose_hint">
        <el-form  label-width="100px"  :label-position="labelPosition">
            <el-form-item :label="$t('chat.Selectgroup')"  :required="true">
              <el-select v-model="comprador" :placeholder="$t('chat.Pleaseselectgroup')" style="width:100%" @change="comprador_change">
                <el-option
                  v-for="item in customgroup"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item :label="$t('chat.Addgroup')" >
               <el-button type="primary" @click="addnewgrop_btn">{{$t('chat.AddingaNewGroup')}}</el-button>
            </el-form-item>
            <el-form-item :label="$t('chat.Userstories')" >
              <el-input type="textarea" v-model="description" :rows=5></el-input>
            </el-form-item>
            
          </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="closehint">{{$t('chat.cancel')}}</el-button>
          <el-button type="primary" @click="successshint">{{$t('chat.confirm')}}</el-button>
        </span>
      </el-dialog>
    <!-- 添加买家到分组 -->
    <el-dialog :title="$t('chat.hint')" :visible.sync="dialogVisible" width="30%">
      <el-row class="center">
        <ul>
          <li>
            <el-image :src="sendImgUrl" fit="contain"></el-image>
          </li>
        </ul>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendImg(false)">{{$t('chat.cancel')}}</el-button>
        <el-button type="primary" @click="sendImg(true)">{{$t('chat.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import "./components";
import api from "../../api/moudles/chat";
import { mapState, mapActions } from "vuex";
import echarts from "echarts";
import axios from "axios";
import remind from "../../api/moudles/remind";
import chat from '../../api/moudles/chat';
// import chat from '../../api/moudles/chat';
let id = 1000;
export default {
  data() {
    return {
      firstScrollTop:'',//记录离开页面时滚动条的位置
      highData:[],
      currentPage:1,
      currentPagesize:10,
      currentPage4:1,
      currentPagesize4:10,
      qutotal:null,//搜索总条目数
      hightital:null,
      qestionvalue:'',//搜索的关键字
      flag:true,
       setting:[],
       checkboxGroup2:[],
       cities:[this.$t("chat.Monday"), this.$t("chat.Tuesday"), this.$t("chat.Wednesday"),this.$t("chat.Thursday"),this.$t("chat.Friday"),this.$t("chat.Saturday"),this.$t("chat.Sunday")],
      response:false,
      monday:false,//星期一
      tuesday:false,//星期二
      wednesday:false,//星期三
      thursday:false,//星期四
      friday:false,//星期五
      saturday:false,//星期六
      sunday:false,//星期日
      mondaynum:'',//星期一
      tuesdaynum:'',//星期二
      wednesdaynum:'',//星期三
      thursdaynum:'',//星期四
      fridaynum:'',//星期五
      saturdaynum:'',//星期六
      sundaynum:'',//星期日
      openrecomd:false,
      questionopen:false,
      highstaus:false,
      showStatus:'',//自动回复按钮
      result:null,//是否已经授权
      tags:[],//用户所属分组
      command_value:1,//翻译语言
      ruleForm: {
          pass: '',
          checkPass: '',
          
        },
      addnewgrop:false,//添加新的分组弹窗
      comprador:'',
      description:'',
      labelPosition:'left',
      custom_hint:false,
       gridData: [],
       similarData:[],
       answerRecommend:[],//机器学习智能回复
       answerthree:[],//前三天条数据
       questionget:[],//搜索匹配结果
      reply:false,
      expression:[],
      sticker_img:{
            "004,shogi2":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/004@1x.png",
            "0003,shogi4":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0003@1x.png",
            "0008,shogi_th":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0008@1x.png",
            "0003,shogi_th":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0003@1x.png",
            "0001,shogi_th":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0001@1x.png",
            "0004,shogi3":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0004@1x.png",

             "016,shogi2":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/016@1x.png",
              "0004,shogi4":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0004@1x.png",
              "0002,shogi3":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0002@1x.png",
              "002,shogi2":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/002@1x.png",
              // "0004,shogi4":"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0004@1x.png"
             
      },
      sticker:[
        {
          sticker_id:"004",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/004@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0003@1x.png"
        },
        {
          sticker_id:"0008",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0008@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0003@1x.png"
        },
        {
          sticker_id:"0001",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0001@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0004@1x.png"
        },
        {
          sticker_id:"016",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/016@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0004@1x.png"
        },
        {
          sticker_id:"0002",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0002@1x.png"
        },
        {
          sticker_id:"002",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/002@1x.png"
        }
      ],
      checked:false,
      questions_o: [],
      questions_b: [
        {
          value: "",
        },
      ],
      user_hj: null,
      score: "5",
      buyerUser: [], //用户画像数据
      category_user: [], //用户画像分类数据
      collapse_name: "1",
      amend: false, //修改问答弹窗
      amend_kj:false,//快捷回复修改回答弹窗
      tabName: "", //分组名
      remarks: false, //备注内容弹窗
      remark: "", //备注内容
      add_remark: "", //传到后台的备注内容
      search_text: this.$t("chat.Allthequery"), //搜索框的值
      closecau: false,
      btn_fy: "1",
      cause: [
        {
          value: "OUT_OF_STOCK",
          label: "OUT_OF_STOCK",
        },
        {
          value: "CUSTOMER_REQUEST",
          label: "CUSTOMER_REQUEST",
        },
        {
          value: "UNDELIVERABLE_AREA",
          label: "UNDELIVERABLE_AREA",
        },
        {
          value: "COD_NOT_SUPPORTED",
          label: "COD_NOT_SUPPORTED",
        },
      ],
      causes: "",
      goods: [
        {
          value: "1",
          label: this.$t("chat.English"),
        },
        {
          value: "2",
          label: this.$t("chat.Thai"),
        },
        {
          value: "3",
          label: this.$t("chat.Malay"),
        },
        {
          value: "4",
          label: this.$t("chat.Chinese"),
        },
        {
          value: "5",
          label: this.$t("chat.Vietnamese"),
        },
        {
          value: "6",
          label: this.$t("chat.Indonesian"),
        },
        {
          value: "7",
          label: this.$t("chat.spanish"),
        },
        {
          value: "8",
          label: this.$t("chat.Portuguese"),
        }
      ],
      languages: "1",
      voluntarily:"1",
      formInline: {
        user: "",
        region: "",
      }, //智能回复form表单
      editableTabsValue: "1",
      editableTabs: [
        {
          title: "答案1",
          name: "1",
          content: "",
        },
      ],
      tabIndex: 1, //答案tabs组件

      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      }, //添加问题form表单
      input: "", //表单搜索文字
      labelPosition: "left",
      labelPositions: "top",
      value: [],
      dynamicValidateForm: {
        domains: [],
        email: "",
      }, //增加问题
      optionso: [],
      value_grop: "", //选择的分类
      value_grop_so: "", //选择的分类
      tableData: [],
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      dialogVisible_node: false, //添加根节点弹窗
      modify: false, //修改的根节点名称弹窗
      input_node_modify: "", //修改的根节点名称
      negative_id: "", //当前要修改的根节点id
      similarity: [], //相似问题
      knowledgeId_id: "", //修改的知识id
      problem: "", //相似问题
      createTime: "", //当前修改知识的创建时间
      status: "", //当前修改知识得状态
      negative_name: "", //当前要修改的根节点名称
      node_son: false, //添加子节点弹窗
      node_node: "",
      node_data: "",
      input_node: "", //根节点名称
      input_node_son: "", //添加子节点名称
      value1: true, //禁用开关
      issue: false, //添加问题弹框
      issue_kj: false, //快捷回复添加问题弹窗
      classify: false, //分类管理开关
      values: "", //问题答案
      count: 0,
      aside: true,
      select: "-1",
      selects: "",

      textarea: "",
      tab: false,
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      search: null,
      shopId: null,
      conversationList: null,
      conversationList_: null,
      conversationData: {
        toName: "",
      },
      conversationHistory: null,
      conversationHistory_: null,
      authorizedShopList: null,
      conversationHistoryParams: null,

      fromId: null,
      toId: null,
      toShopId: null,
      shopName: null,
      countryName:{
			                    'TH':this.$t("chat.Thailand"),
			                    'PH':this.$t("chat.thePhilippines"),
			                    'MY':this.$t("chat.Malaysia"),
			                    'ID':this.$t("chat.Indonesia"),
			                    'SG':this.$t("chat.Singapore"),
			                    'TW':this.$t("chat.Taiwan"),
			                    'VN':this.$t("chat.Vietnam")
			                },
      div: null,
      upload: null,
      filters: {
        pageNum: 0,
        pageSize: 10,
      },
      pageSize_: null,
      dialogVisible: false,
      sendImgUrl: null,
      toAvatar: "",
      stacontent:null,
      uploadConversation: null,
      toLanguage: "", //当前翻译语种
      sendInit: "", //发送原文
      mouseover: "",
      activeIndex: "first",
      unread: null,
      unreadData: {},
      visible: false,
      searchFilters: {
        pageNum: 0,
        pageSize: 10,
        queryString: null,
      },
      orderData: null,
      translateData: {
        COMPLETED: this.$t("chat.completed"),
        CANCELLED: this.$t("chat.canceled"),
        SHIPPED: this.$t("chat.transport"),
        UNPAID: this.$t("chat.uNPAID"),
        READY_TO_SHIP: this.$t("chat.rEADY_TO_SHIP"),
        TO_CONFIRM_RECEIVE: this.$t("chat.tO_CONFIRM_RECEIVE"),
        PROCESSED: this.$t("chat.pROCESSED"),
        IN_CANCEL:this.$t("chat.pending")
      },
      chatLoading: true,
      orderLoading: false,
      shortcutGroup: null,
      shortcutGroupData: null,
      shortcutMessageData: null,
      shortcutMessage: "",
      showInput: false,
      searchMessage_: true,
      groupName: "",
      latestMessageType: {
        image: this.$t("chat.image"),
        order: this.$t("chat.order"),
        item: this.$t("chat.item"),
        sticker: this.$t("chat.sticker"),
      },
      scorllstatus: true,
      ifModifyMessageIndex: null,
      modifyGroup: true,
      modifyGroupName: "",
      modifyMessage_: "",
      order_cancels: "", //要取消的订单号
      remark_order: "", //备注的订单号
      language:'',//自动翻译选择的语言
      toLanguage:'',//自定义翻译选择的语言
      table_translation: {
        Lossed: 1,
        Lossing:2,
        ordinary:3,
        
        loyal: 4,
        loyalIII: 3,
        loyalII: 2,
        loyalI: 1,
        PriceInsensitivity: this.$t('chat.Priceinsensitive'),
        PriceSensitive: this.$t('chat.pricesensitive'),
        Ordinary: 3,
        
       
        HighConsumption: this.$t('chat.Highspendingpower'),
        
        LowConsumption: this.$t('chat.lowconsumption'),
        
      },
      tble_user:{
        Ordinary: this.$t('chat.common'),
        ordinary:this.$t('chat.common'),
        PriceInsensitivity:this.$t('chat.Priceinsensitive'),
        PriceSensitive: this.$t('chat.pricesensitive'),
        
       
        HighConsumption: this.$t('chat.Highspendingpower'),
        
        LowConsumption: this.$t('chat.lowconsumption'),
      },
      option: {
        title: {
          text: "姓名: dotgroup",
        },

        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
        },
        radar: {
          indicator: [
            { name: "相对类目均价平均消费溢价比",min:-1,max:1  },
            { name: "订单拒收数",min:-1,max:1  },
            { name: "订单数(消费次数)",min:-1,max:1 },
            { name: "最近一次消费至今间隔",min:-1,max:1 },
            { name: "平均消费时间间隔",min:-1,max:1  },
            { name: "总消费金额",min:-1,max:1  },
          ],
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [],
                name: "用户画像",
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgb(198, 226, 255)",
                      offset: 0,
                    },
                    {
                      color: "rgb(83, 168, 255)",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      },
      popoverVisible:false,
      pitch:false,
      translationArr:[],
      originalTranslationArr:[],
      answers:[],
      customgroup:[],
      companyList:[{
        id:1,
        user_name:this.$t('chat.English')
      },
      {
        id:2,
        user_name:this.$t('chat.Thai')
      },
      {
        id:3,
        user_name:this.$t('chat.Malay')
      },],
      shopsGroupByRegion:[{
        region:1,
        children:[{
          shopName:2
        }]
      }],
      country:'',
      contentData:[],//自定义回复数组
      mes_content:false,
      textarea_content:'',
      speediness:'',//快速翻译
      matchMessageId :'',//当用户发送的消息点击推荐内容的时候，对应到的推荐内容匹配到的消息ID
      answerType :'MANUAL_INPUT',//回答类型，MANUAL_INPUT(手动输入), RECOMMEND(推荐回答), PATTERN_MATCH(精确匹配)
    };
  },
  async mounted() {
    this.talkPanelScrollBottom();
    this.getShopList();
    this.echart();
    this.getShortcutGroup();
    // this.get_tree();//获取目录树
    this.tabclick(); //获取默认目录下的所有知识
    // this.tabclick_kj();//获取快捷回复功能下的所有知识
    this.getcustom();//获取用户自定义分组
    // this.getcustommessage();//获取用户得自定义回复
    // this.getstore();
    this.connectWebsocket();//Websocket链接
  },
  activated() {
    this.talkPanelScrollBottom();
    // if(this.tab == true){
    //   this.$refs.firstWrapper.scrollTop = this.firstScrollTop;
    // }
    // this.$refs.firstWrapper.scrollTop = this.firstScrollTop;
    },//在vue对象存活的情况下，进入当前存在activated()函数的页面时，一进入页面就触发
//   beforeRouteLeave (to, from, next) { 
//     if(this.tab == true){
//       this.firstScrollTop = this.$refs.firstWrapper.scrollTop;
     
//         next();
//     }
      
//  },

  computed: {
    ...mapState({
      options: (state) => state.chat.options,
      shopList: (state) => state.shopaccess.shopInfo || "",
      userId: (state) => state.shopaccess.userInfo.userId,
      
      
    }),
  },
  watch: {
    shortcutGroup() {
      this.getShortcutMessage();
      this.groupName = "";
      this.modifyGroupName = "";
      this.modifyMessage_ = "";
      this.ifModifyMessageIndex = null;
      this.showInput = false;
      this.shortcutMessage = "";
    },
  },
  methods: {
    ...mapActions("chat", []),
    changestacker(e){
     
      // this.stacontent = e;
      // var str = this.stacontent.split(",");
      
      // var det = str[0];
      // console.log(det)
      // return det;
      
    },
    addmessage(){
      this.mes_content = true;
    },//添加自定义回复
    closemes(){
      this.mes_content = false;
      this.textarea_content = '';
    },
    addmes(){
       remind
        .getuserauto({
          content : this.textarea_content,
          userId  : this.userId,
          shopId : this.shopId
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.$message({
          message: this.$t('chat.successfullyadded'),
          type: 'success'
        });
         this.getcustommessage();
          }
          
          
        });
        this.mes_content = false;
        this.textarea_content = '';
    },
    editmessage(){ 
      this.mes_content = true;
    },//修改自定义回复
    getcustommessage(){
      console.log(this.shopId);
      remind
        .getuserreplay({
          shopId :this.shopId,
          userId  : this.userId,
          
        })
        .then((res) => {
         console.log(res);
         this.showStatus = res.content.isAutoReply;
         this.contentData = res.content;
         console.log(this.contentData);
          
        });
    },
    getrepones(){
     
      remind
        .getantomatic({
          shopId :this.shopId,
          userId  : this.userId,
          
        })
        .then((res) => {
          console.log('获取店铺的日期设置')
         console.log(res);
         //        monday:false,//星期一
      // thursday:false,//星期二
      // wednesday:false,//星期三
      // thursday:false,//星期四
      // friday:false,//星期五
      // saturday:false,//星期六
      // sunday:false,//星期日
          if(res.shopAutoReply.monday=='1'){
            this.monday = true;
            this.mondaynum = '1';
          }else{
             this.mondaynum = '0';
          }

          if(res.shopAutoReply.tuesday=='1'){
            this.tuesday = true;
            this.tuesdaynum = '1';
          }else{
            this.tuesdaynum = '0';
          }

          if(res.shopAutoReply.wednesday=='1'){
            this.wednesday = true;
            this.wednesdaynum = '1';
          }else{
            this.wednesdaynum = '0';
          }

          if(res.shopAutoReply.thursday=='1'){
            this.thursday = true;
            this.thursdaynum = '1';
          }else{
            this.thursdaynum = '0';
          }

          if(res.shopAutoReply.friday=='1'){
            this.friday = true;
            this.fridaynum = '1';
          }else{
            this.fridaynum = '0';
          }

          if(res.shopAutoReply.saturday=='1'){
            this.saturday = true;
            this.saturdaynum = '1';
          }else{
            this.saturdaynum = '0';
          }
          if(res.shopAutoReply.sunday=='1'){
            this.sunday = true;
            this.sundaynum = '1';
          }else{
            this.sundaynum = '0';
          }
        });
    },
     handleCheckedCitiesChange(value) {
        console.log(value);
        // console.log(this.setting);
      },
      mondayopen(){
        console.log(this.monday);
        if(this.monday){
          this.mondaynum = '1';
        }else{
          this.mondaynum = '0'
        }
        console.log(this.mondaynum);
      },//复选框选择星期一
      tuesdayopen(){
        console.log(this.tuesday);
        if(this.tuesday){
          this.tuesdaynum = '1';
        }else{
          this.tuesdaynum = '0'
        }
        console.log(this.tuesdaynum);
      },//复选框选择星期二
      wednesdayopen(){
        console.log(this.wednesday);
        if(this.wednesday){
          this.wednesdaynum = '1';
        }else{
          this.wednesdaynum = '0'
        }
        console.log(this.wednesdaynum);
      },//复选框选择星期三
      thursdayopen(){
        console.log(this.thursday);
        if(this.thursday){
          this.thursdaynum = '1';
        }else{
          this.thursdaynum = '0'
        }
        console.log(this.thursdaynum);
      },//复选框选择星期四
      fridayopen(){
        console.log(this.friday);
        if(this.friday){
          this.fridaynum = '1';
        }else{
          this.fridaynum = '0'
        }
        console.log(this.fridaynum);
      },//复选框选择星期五
      saturdayopen(){
        console.log(this.saturday);
        if(this.saturday){
          this.saturdaynum = '1';
        }else{
          this.saturdaynum = '0'
        }
        console.log(this.saturdaynum);
      },//复选框选择星期六
      sundayopen(){
        console.log(this.sunday);
         if(this.sunday){
          this.sundaynum = '1';
        }else{
          this.sundaynum = '0'
        }
        console.log(this.sundaynum);
      },//复选框选择星期日
      responsesucc(){
      //    mondaynum:'',//星期一
      // tuesdaynum:'',//星期二
      // wednesdaynum:'',//星期三
      // thursdaynum:'',//星期四
      // fridaynum:'',//星期五
      // saturdaynum:'',//星期六
      // sundaynum:'',//星期日
      
          remind
        .setantomatic({
          shopId : this.shopId,
          userId : this.userId,
          monday :this.mondaynum,
          tuesday :this.tuesdaynum,
          wednesday :this.wednesdaynum,
          thursday :this.thursdaynum,
          friday :this.fridaynum,
          saturday :this.saturdaynum,
          sunday : this.sundaynum
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.getrepones();
            this.$message({
          message: this.$t('chat.successfullyset'),
          type: 'success'
        });
         this.response = false;
          }
          
          
        });
        
       
      },//确定更新
    openresponse(){
      this.response = true;
       this.getrepones();
    },//打开自动回复日期设置弹窗
    Closeresponse(){
      this.response = false;
      
    },//关闭自动回复日期设置弹窗
    updateBrandStatus(e){
      console.log(e);
      remind
        .getuserauto({
          isAutoReply : e,
          userId  : this.userId,
          shopId : this.shopId
        })
        .then((res) => {
          console.log(res);
          if(res.autoReply.isAutoReply == 1){
            this.$alert(this.$t('chat.tips'), this.$t('chat.hint'), {
          confirmButtonText: this.$t('chat.confirm'),
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
         
          }else{
             this.$message({
          message:this.$t('chat.hasbeendisabled'),
          type: 'success'
        });
          }
          
          
        });

    },//开启和关闭自动回复
    synchronously(){
      remind
        .syncshopmessage({
          shopId : this.shopId
        })
        .then((res) => {
          if(res.code == 'ok'){
            this.$message({
          message: this.$t('chat.Sessionsucceeded'),
          type: 'success'
        });
         this.getConversationList(this.filters);
          }
          
          
        });
    },//同步会话
    openAuthorization(){
			 let url=location.href
			 let baseUrl=''
			console.log(url)
			if(url.indexOf('dianxiaosheng') > -1) {
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=5c9174fc6006107dfb919c806da054e7725e35473afb4e0b7a943d61f9070620&redirect=https://erp.dianxiaosheng.com/index'
			}else if(url.indexOf('weanaly') > -1){
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=ab433e8f80128cda181fc4cdad8a220ef72f58e4e0b9335ce52aa58020cc551b&redirect=https://erp.weanaly.com/index'
			}else if(url.indexOf('shopsbu') > -1){
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=b1b5f7336c83f97eccb7dca3a93ff9756b16ef3809be2d9cca7c58ad39cba49d&redirect=https://erp.shopsbu.com/index'
			}	
			window.open(baseUrl)
			// this.$message.warning('正在跳转授权页面，请稍候...')
			// setTimeout(() => {
			// 	window.location.href=baseUrl
			// },700)
			
    },//授权店铺
    //更改翻译语言
    updatelange(language){
      
      remind
        .updateshopautomatic({
          // autoTranslateStatus  : status,
          language :language,
          // toLanguage :this.toLanguage,
          shopId : this.shopId,
          userId : this.userId
        })
        .then((res) => {
          console.log(res);
          
        });
    },
    //更改自定义翻译语言
    updatetolange(toLanguage){
      
      remind
        .updateshopautomatic({
          
          // language :language,
          toLanguage :toLanguage,
          shopId : this.shopId,
          userId : this.userId
        })
        .then((res) => {
          console.log(res);
          
        });
    },
    openrecomdopr(){
      console.log(this.voluntarily);
      console.log(this.languages);
      this.openrecomd = true;
      
      switch (this.voluntarily) {
        case "1":
          this.language = this.$t("chat.English");
          break;
        case "2":
           this.language = this.$t("chat.Thai");
          break;
        case "3":
           this.language = this.$t("chat.Malay");
          break;
        case "4":
           this.language = this.$t("chat.Chinese");
          break;
        case "5":
            this.language = this.$t("chat.Vietnamese");
          break;
        case "6":
           this.language = this.$t("chat.Indonesian");
          break;
        case "7":
            this.language = this.$t("chat.spanish");
          break;
        case "8":
           this.language = this.$t("chat.Portuguese");
          break;
        default:
          break;
      }

      switch (this.languages) {
        case "1":
          this.toLanguage = this.$t("chat.English");
          break;
        case "2":
           this.toLanguage = this.$t("chat.Thai");
          break;
        case "3":
           this.toLanguage = this.$t("chat.Malay");
          break;
        case "4":
           this.toLanguage = this.$t("chat.Chinese");
          break;
        case "5":
            this.toLanguage = this.$t("chat.Vietnamese");
          break;
        case "6":
           this.toLanguage = this.$t("chat.Indonesian");
          break;
        case "7":
            this.toLanguage = this.$t("chat.spanish");
          break;
        case "8":
           this.toLanguage = this.$t("chat.Portuguese");
          break;
        default:
          break;
      }
    },
    langeone(e,index){
      console.log(e.answer);
      // console.log(this.answerRecommend[index]);
      switch (this.voluntarily) {
        case "1":
          
            this.quTranslate('en',e.answer,e);
            
          break;
        case "2":
            this.quTranslate('th',e.answer,e);
           
          break;
        case "3":
           this.quTranslate('ms',e.answer,e);
           
          break;
        case "4":
           this.quTranslate('zh-cn',e.answer,e);
           
          break;
        case "5":
           this.quTranslate('vi',e.answer,e);
           
          break;
        case "6":
           this.quTranslate('id',e.answer,e);
           
          break;
        case "7":
            this.quTranslate('es',e.answer,e);
            
          break;
        case "8":
            this.quTranslate('pts',e.answer,e);
          
          break;
        default:
          break;
      }
    
    },
    langetwo(e,index){
       switch (this.languages) {
        case "1":
          
            this.quTranslate('en',e.answer,e);
            
          break;
        case "2":
            this.quTranslate('th',e.answer,e);
           
          break;
        case "3":
           this.quTranslate('ms',e.answer,e);
           
          break;
        case "4":
           this.quTranslate('zh-cn',e.answer,e);
           
          break;
        case "5":
           this.quTranslate('vi',e.answer,e);
           
          break;
        case "6":
           this.quTranslate('id',e.answer,e);
           
          break;
        case "7":
            this.quTranslate('es',e.answer,e);
            
          break;
        case "8":
            this.quTranslate('pts',e.answer,e);
          
          break;
        default:
          break;
      }
    },
    // 翻译当前输入框的文字为指定内容
    quTranslate(toLanguage,text,e) {
      
      
        api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: text,
            toLanguage: toLanguage,
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              this.$set(e,'answer',res.translation)
            }else if(res.code=='failed'){
                this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
            
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
      
    },
    updatestore(status){
     
      
        remind
        .updateshopautomatic({
          autoTranslateStatus  : status,
          // language :this.language,
          // toLanguage :this.toLanguage,
          shopId : this.shopId,
          userId : this.userId
        })
        .then((res) => {

          console.log(res);
          
        });
    },//更新店铺自动翻译设置的状态

    examineshop(){
      remind
        .getauth({
          shopId : this.shopId
        })
        .then((res) => {
          console.log('1111')
          this.result = res.result;
          console.log(this.result);

          
        });
    },//查看某个店铺是否授权shopee v1版本
    addnewgropcli(){
      remind
        .createcategory({
          categoryName : this.ruleForm.pass,
          description:this.ruleForm.checkPass,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.$message({
          message: this.$t("chat.successfullyadded"),
          type: 'success'
        });
          this.getcustom();
          }
          
        });
        this.ruleForm.pass = '';
        this.ruleForm.checkPass = '';
        this.addnewgrop = false;
    },//添加新的用户分组
    addnewgropcos(){
        this.ruleForm.pass = '';
        this.ruleForm.checkPass = '';
        this.addnewgrop = false;
    },
    addnewgrop_btn(){
      this.addnewgrop = true
    },
    comprador_change(){
      console.log(this.comprador);
    },
    getcustom(){
      remind
        .getcustomgroup({
          pageNum : 1,
          pageSize: 20,
          userId: this.userId,
        })
        .then((res) => {
          console.log('自定义分组')
          console.log(res.categories);
          this.customgroup = res.categories;
          this.comprador = this.customgroup[0].categoryId;
        });
    },
    successshint(){
        remind
        .insertconsumer({
          categoryId  : this.comprador,
          consumerName : this.conversationData.toName,
          description　: this.description,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
             this.$message({
          message: this.$t("chat.successfullyadded"),
          type: 'success'
        });
        this.getusergroup_ck();//刷新用户分组标签
          }
          if(res.code == 'failed'){
            this.$message({
          message: res.msg,
          type: 'warning'
        });
          }
          
        });
        this.comprador = '';
      this.description = '';
        this.custom_hint = false;
    },//添加到分组
    closehint(){
      this.comprador = '';
      this.description = '';
      this.custom_hint = false;

    },//关闭分组弹框
    opentoname(){
      this.comprador = this.customgroup[0].categoryId;
      this.custom_hint = true
    },
     handleCommand_Cc(command) {
       console.log(command)
        this.$message('click on item ' + command);
      },//将买家添加到特定分组
    //显示问题详情列表 
        contentDetail(index,row) {
          console.log(row);
           this.answers = JSON.parse(row.similarQuestion);
           console.log(this.answers);
        },
    pitchknow(index,row){
      console.log(index,row);
      this.textarea = row.answer;
    },
    pitchmes(e){
      console.log(e);
      this.textarea = e;
    },
    openrecom(){
      console.log('打开提示回复')
      this.openrecomd = true
    },
    closerecon(){
      this.openrecomd = false
    },
    questionback(){
      this.questionopen = false;
      this.currentPage4 = 1;
    },
    questioncon(){
      this.questionopen = false;
      this.currentPage4 = 1;
    },
    selectanswer(e){
      console.log(e);
      this.answerType = e.type;
      this.matchMessageId = e.messageId;
      this.textarea = e.answer;
     this.openrecomd = false;
    },
    chckeanswer(e){
      console.log(e);
      this.answerType = e.type;
      this.matchMessageId = e.messageId;
      this.textarea = e.answer;
    },
    sendface(e){
      console.log(e)
      console.log(this.conversationData.conversationId)
      this.expression.push(e.sticker_id);
      this.expression.push(e.sticker_package_id);
      console.log(JSON.stringify(this.expression));
      const homeex = this.expression.join(",")
      console.log(JSON.stringify(homeex));

      api
          .sendMessage({
            content: homeex,
            conversationId: this.conversationData.conversationId,
            fromId: this.fromId,
            messageType: "sticker",
            shopId: this.shopId,
            toId: this.toId,
            toShopId: this.toShopId,
          })
          .then((res) => {
            if (res.code == "ok") {
              
              this.conversation(this.conversationData);
            }
          });
          this.expression = [];
    },//发送表情包
    goodsdetail_vo(){
      console.log(this.voluntarily);
       console.log(this.checked);
      switch (this.voluntarily) {
        case "1":
          
            this.updatelange('en')
          break;
        case "2":
           
            this.updatelange('th');
          break;
        case "3":
           
            this.updatelange('ms');
          break;
        case "4":
           
            this.updatelange('zh-cn');
          break;
        case "5":
            
            this.updatelange('vi');
          break;
        case "6":
           
            this.updatelange('id');
          break;
        case "7":
           
            this.updatelange('es');
          break;
        case "8":
           
            this.updatelange('pt');
          break;
        default:
          break;
      }
      this.checkchang();//实时翻译
    },
    goodsdetail() {
      console.log(this.languages);
      switch (this.languages) {
        case "1":
          
            this.updatetolange('en')
          break;
        case "2":
           
            this.updatetolange('th');
          break;
        case "3":
           
            this.updatetolange('ms');
          break;
        case "4":
           
            this.updatetolange('zh-cn');
          break;
        case "5":
            
            this.updatetolange('vi');
          break;
        case "6":
           
            this.updatetolange('id');
          break;
        case "7":
           
            this.updatetolange('es');
          break;
        case "8":
           
            this.updatetolange('pt');
          break;
        default:
          break;
      }
    },
     getstore(){
      remind
        .getshopautomatic({
          shopId : this.shopId,
          userId : this.userId
        })
        .then((res) => {
          console.log('状态');
          console.log(res.autoTranslate.language);
          console.log(res.autoTranslate.toLanguage);
          console.log(res.autoTranslate.autoTranslateStatus);
          console.log(this.voluntarily);
          if(res.code=='ok'){
             if(res.autoTranslate.autoTranslateStatus=='1'){
                    this.checked = true;
                  
                  }else{
                    this.checked = false;
                  }
          }
          // this.checkchang();
          if(res.autoTranslate.language=='en'){
            this.voluntarily = '1';
           
          }else if(res.autoTranslate.language=='th'){
            this.voluntarily = '2';
           
          }else if(res.autoTranslate.language=='ms'){
            this.voluntarily = '3';
            
          }else if(res.autoTranslate.language=='zh-cn'){
            this.voluntarily = '4';
            
          }else if(res.autoTranslate.language=='vi'){
            this.voluntarily = '5';
           
          }else if(res.autoTranslate.language=='id'){
            this.voluntarily = '6';
           
          }else if(res.autoTranslate.language=='es'){
            this.voluntarily = '7';
           
          }else if(res.autoTranslate.language=='pt'){
            this.voluntarily = '8';
           
          }

          if(res.autoTranslate.toLanguage=='en'){
           
            this.languages = '1';
          }else if(res.autoTranslate.toLanguage=='th'){
            
            this.languages = '2';
          }else if(res.autoTranslate.toLanguage=='ms'){
            
            this.languages = '3';
          }else if(res.autoTranslate.toLanguage=='zh-cn'){
            
            this.languages = '4';
          }else if(res.autoTranslate.toLanguage=='vi'){
            
            this.languages = '5';
          }else if(res.autoTranslate.toLanguage=='id'){
            
            this.languages = '6';
          }else if(res.autoTranslate.toLanguage=='es'){
            
            this.languages = '7';
          }else if(res.autoTranslate.toLanguage=='pt'){
           
            this.languages = '8';
          }
       
          
          
        });
    },//获取店铺自动翻译状态
    checkchang(){
        console.log(this.checked);
        if(this.checked == true){
          
          this.updatestore('1');
          api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: '你好',
            toLanguage: 'en',
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              
            }else if(res.code=='failed'){
               this.$message({
          message: res.msg,
          type: 'warning'
        });
        this.checked = false;
        this.updatestore('0');
            }
            
          });
          console.log(this.voluntarily);
            switch (this.voluntarily) {
        case "1":
          
            this.translateAllConversationHistory("en");
            // this.updatelange('en');
          break;
        case "2":
            this.translateAllConversationHistory("th");
            // this.updatelange('th','1');
          break;
        case "3":
            this.translateAllConversationHistory("ms");
            // this.updatelange('ms','1');
          break;
        case "4":
            this.translateAllConversationHistory("zh-cn");
            // this.updatelange('zh-cn','1');
          break;
        case "5":
            this.translateAllConversationHistory("vi");
            // this.updatelange('vi','1');
          break;
        case "6":
            this.translateAllConversationHistory("id");
            // this.updatelange('id','1');
          break;
        case "7":
            this.translateAllConversationHistory("es");
            // this.updatelange('es','1');
          break;
        case "8":
            this.translateAllConversationHistory("pt");
            // this.updatelange('pt','1');
          break;
        
        default:
          break;
      }
          

          // this.translateAllConversationHistory("en");
        }else{
          this.updatestore('0');
     
      
        }
    },//是否开启自动翻译
    //汇率转换
    money(num) {
      var lastmoney = (num * 6.3756).toFixed(2);
      return lastmoney;
    },
    setEchart() {
      var chartDom = document.getElementById("categoryPortraitEchart");
      var myChart = echarts.init(chartDom);
      var option = {
        // title: {
        //   text: "姓名: dotgroup",
        // },

        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
        },
        radar: {
          indicator: [
            { name: this.$t('chat.Consumptioratio'),min:-1,max:1  },
            { name: this.$t('chat.rejectedorders'),min:-1,max:1  },
            { name: this.$t('chat.Numbeconsumption'),min:-1,max:1 },
            { name: this.$t('chat.Lastdate'),min:-1,max:1 },
            { name: this.$t('chat.consumptioninterval'),min:-1,max:1 },
            { name: this.$t('chat.Totalconsumption'),min:-1,max:1  },
          ],
        },
        series: [
          {
            name: "",
            type: "radar",
            // tooltip: {
            //   trigger: "item",
            // },
            data: [
              {
                value: [],
                name: "用户画像",
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgb(198, 226, 255)",
                      offset: 0,
                    },
                    {
                      color: "rgb(83, 168, 255)",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      };

          var arr = [];
          if(this.buyerUser!="" && this.buyerUser!=null){
              for (var i in this.buyerUser.standard) {
        
          arr.push(this.buyerUser.standard[i]);
       
      
          
          }
          }
              
          
      
      console.log(arr);
      option.series[0].data[0].value = arr;
      // option.title.text = "姓名:" + this.buyerUser.consumerName;
      option && myChart.setOption(option);
    },
    //用户画像
    user_portrayal() {
      api
        .getbuyeran({
          buyerUserName: this.conversationData.toName,
          userId: this.userId,
        })
        .then((res) => {
          console.log("55555");
          // console.log(res.buyerUserPortrait.buyerUserPortrait);
          // console.log(res.buyerUserPortrait)
          this.buyerUser = res.buyerUserPortrait.buyerUserPortrait;
          this.category_user = res.buyerUserPortrait.categoryAverage;
          console.log(this.buyerUser);
          console.log(this.category_user);

          if (this.buyerUser != "" && this.buyerUser != null) {
            this.user_hj = this.table_translation[this.buyerUser.loyaltyLevels];
          }
          
           
         setTimeout(() => {
           this.setEchart(); //生成用户图表   
         }, 2000);
        
     
          
        });
    },
    //获取不同分类下的所有知识
    tabclick() {
      console.log(this.tabName);
      api
        .getknowledge({
          categoryId: this.tabName,
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.knowledge;
        });
    },
    //快捷回复按钮切换
    tabclick_kj() {
      console.log(this.shortcutGroup);
      api
        .getknowledge({
          categoryId: this.shortcutGroup,
        })
        .then((res) => {
          console.log(res);
          this.shortcutMessageData = res.knowledge;
          console.log(this.shortcutMessageData);
          // this.tableData = res.knowledge;
        });
    },
    getdomain(e) {
      console.log(e);
      this.similarity.push(e);
      console.log(this.similarity);
    },
    //分类改变的值
    changevalue() {
      console.log(this.value_grop);
      console.log(this.value_grop_so);
    },
    //获取目录树
    get_tree() {
      api
        .gettree({
          userId: this.userId,
        })
        .then((res) => {
          console.log("目录树");
          console.log(res);

          this.optionso = res.tree;
          //  this.tabName = this.optionso[0].groupId
          //  console.log('list')
          //  console.log(this.optionso)
          //  console.log(this.tabName)
          // console.log(this.optionso);
        });
    },
    //添加根节点
    appendfirst() {
      this.dialogVisible_node = true;
      // const newparnt = {id:id++,label:'parent',children: [] };
      // this.optionso.push(newparnt);
    },
    //根节点添加
    node_add() {
      console.log(this.input_node);

      api
        .addGroup({
          groupName: this.input_node,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.$message({
              message: this.$t("chat.successfullyadded"),
              type: "success",
            });
            this.getShortcutGroup();
          } else {
            this.$message.error(this.$t("chat.additionfailed"));
          }
        });
      this.input_node = "";
      this.dialogVisible_node = false;
    },
     handleSizeChange(val) {
       this.currentPagesize4 = val;
        console.log(`每页 ${val} 条`);
        chat
        .getqestion({
          pageNum : this.currentPage4,
          pageSize :this.currentPagesize4,
          queryString : this.qestionvalue,
        })
        .then((res) => {
          if(res.code=='ok'){
            if(res.recommendQuestion!=''){
              console.log(res);
              this.questionget = res.recommendQuestion;
             
            }
          }

        });
      },
      handleCurrentChange(val) {
        this.currentPage4 = val;
        chat
        .getqestion({
          pageNum : this.currentPage4,
          pageSize :this.currentPagesize4,
          queryString : this.qestionvalue,
        })
        .then((res) => {
          if(res.code=='ok'){
            if(res.recommendQuestion!=''){
              console.log(res);
              this.questionget = res.recommendQuestion;
              
            }
          }

        });
        console.log(`当前页: ${val}`);
      },
      highfrequency(){
         chat
        .frequqestion({
          pageNum : this.currentPage,
          pageSize :this.currentPagesize,
          
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.highData = res.elements;
            this.highstaus = true;
            this.hightital = res.totalAmount;
          }
          
        });
      },//高频问题
      handleSizeChange_hi(val){
         
       this.currentPagesize = val;
        console.log(`每页 ${val} 条`);
       chat
        .frequqestion({
          pageNum : this.currentPage,
          pageSize :this.currentPagesize,
          
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.highData = res.elements;
           
          }
          
        });
      },
      handleCurrentChange_hi(val){
        this.currentPage = val;
        console.log(`每页 ${val} 条`);
       chat
        .frequqestion({
          pageNum : this.currentPage,
          pageSize :this.currentPagesize,
          
        })
        .then((res) => {
          console.log(res);
          if(res.code == 'ok'){
            this.highData = res.elements;
           
          }
          
        });
      },
      highstauscolse(){
        this.highstaus = false;
      },
      highback(){
        this.highstaus = false;
      },
    searchqestion(){
      console.log('搜索关键字')
      chat
        .getqestion({
          pageNum : this.currentPage4,
          pageSize :this.currentPagesize4,
          queryString : this.qestionvalue,
        })
        .then((res) => {
          if(res.code=='ok'){
            if(res.recommendQuestion!=''){
              console.log(res);
              this.questionget = res.recommendQuestion;
              this.qutotal = res.totalAmount;
              this.questionopen = true;
              // this.qestionvalue = '';   
            }else{
              this.$message(this.$t("chat.Noisavailable"));
            }
          }
         console.log(res.recommendQuestion);
          
        
         
     
          
        });
        
    },
    modify_node_add() {
      console.log(this.negative_id);
      // this.modify = false
      api
        .updateShortcutGroup({
          groupId: this.negative_id,
          groupName: this.input_node_modify,
        })
        .then((res) => {
          if (res.code == "ok") {
            this.$message({
              message: this.$t("chat.modifysuccessfully"),
              type: "success",
            });
            this.modify = false;
            this.getShortcutGroup();
          } else {
            this.$message.error(this.$t("chat.changefailed"));
          }
        });
    }, //根节点修改
    //子节点添加
    node_add_son() {
      console.log(this.node_node);
      console.log(this.node_data);
      api
        .addtree({
          categoryName: this.input_node_son,
          userId: this.userId,
          parentId: this.node_data.groupId,
        })
        .then((res) => {
          console.log(res);
          this.node_son = false;
        });
    },
    //树形控件节点的添加和删除
    append(node, data) {
      this.node_son = true;
      this.node_node = node;
      this.node_data = data;
      console.log(this.node_node);
      console.log(this.node_data);
      // api
      //   .addtree({
      //     categoryName : this.input_node_son,
      //     userId: this.userId,
      //     parentId :data.parentId
      //   })
      //   .then((res) => {
      //     console.log(res);
      //     // this.dialogVisible_node = false;

      //   });
      // const newChild = { id: id++, label: '节点', children: [] };
      //   if (!data.children) {
      //     this.$set(data, 'children', []);
      //   }
      //   data.children.push(newChild);
      this.input_node_son = "";
    },

    deletes(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.id === data.id);
      children.splice(index, 1);
    },
    //添加备注
    closeremarks() {
      this.remarks = false;
    },
    handleNodeClick(data) {
      console.log(data);
    },
    openremark(e) {
      this.remarks = true;
      this.remark = e.note
      console.log(e.order_sn);
      this.remark_order = e.order_sn;
    },
    openremark_xg(e) {
      console.log(e);
      this.remarks = true;
      this.remark = e.note
      this.remark_order = e.order_sn;
      console.log(this.remark_order);
      this.remark = e.note;
    },
    suceedremarks() {
      // this.add_remark = this.remark;
      console.log(this.remark);
      console.log(this.remark_order);
      console.log(this.shopId);
      
      api
        .addremark({
          note: this.remark,
          ordersn: this.remark_order,
          shopId: this.shopId,
        })
        .then((res) => {
          console.log(res);
          this.$notify({
            
            message: res.result.msg,
            type: "success",
          });
          this.conversation(this.conversationData);
          // if (res.code == "ok") {
          //   console.log(res);
          //   this.$notify({
          //     title: "订单",
          //     message: "取消订单成功",
          //     type: "success",
          //   });
          // }
        });
      this.remarks = false;
    }, //添加备注确认按钮
    //取消订单
    cancelorder(e) {
      console.log(this.order_cancels);

      api
        .insertMessage({
          cancelReason: this.causes,
          ordersn: this.order_cancels,
          shopId: this.shopId,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.$notify({
              title: this.$t("chat.order"),
              message: this.$t("chat.cancelledsuccessfully"),
              type: "success",
            });
          }
        });
      this.closecau = false;
    },
    //打开取消订单栏
    closetable(e) {
      this.closecau = true;
      console.log(e.order_sn);
      this.order_cancels = e.order_sn;
    },
    //选择退货原因
    checkcausers() {
      console.log(this.causes);
    },
    //复制订单号
    copyorder(e) {
      console.log(e);
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = e;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      this.$message({
        message:this.$t("chat.Copysuccess"),
        type: "success",
      });
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    copyorders(e) {
      console.log(e);
      // 创建一个 Input标签
      const cInput = document.createElement("input");
      cInput.value = e;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本域内容;
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      this.$message({
        message: this.$t("chat.Copysuccess"),
        type: "success",
      });
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    searchknow() {
      this.tabName = this.value_grop_so;
      this.tabclick();
      api
        .searchknowledge({
          categoryId: this.value_grop_so,
          pageNum: 0,
          pageSize: 10,
          searchString: this.input,
          userId: this.userId,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.tableData = res.knowledge;
          }
        });
    }, //搜索知识
    //问答库数据
    handleEdit(index, row) {
      console.log(index, row);
      this.modify = true;
      this.negative_id = row.groupId;
      this.negative_name = row.groupName;
      this.input_node_modify = row.groupName;
      // updateShortcutGroup
    },
    amendEdit(index, row) {
      console.log(index, row);
      // console.log(JSON.parse(row.similarQuestion));
      this.amend = true;
      this.negative_id = row.categoryId; //分组id
      this.knowledgeId_id = row.knowledgeId; //知识id
      this.formLabelAlign.name = row.question; //问题
      this.createTime = row.createTime; //创建时间
      this.values = row.answer; //问题答案
      this.status = row.status; //问题状态
      if (
        row.similarQuestion == "" ||
        JSON.parse(row.similarQuestion) == null
      ) {
        this.dynamicValidateForm.domains = [];
      } else {
        console.log(JSON.parse(row.similarQuestion));
        this.dynamicValidateForm.domains = JSON.parse(row.similarQuestion);
        // for(let i =0 ;i<JSON.parse(row.similarQuestion).length;i++){

        //    this.questions_b.push(JSON.parse(row.similarQuestion)[i])
        //    this.questions_b.shift();
        // }

        // console.log(this.questions_b);
        // this.dynamicValidateForm.domains = this.questions_b;
        //  this.dynamicValidateForm.domains = JSON.parse(row.similarQuestion);
      }
      console.log(this.dynamicValidateForm.domains);
      //  this.similarity = JSON.parse(row.similarQuestion);
    },
    amendEdit_kj(item){
        console.log(item);
        this.amend_kj = true
        this.negative_id = item.categoryId; //分组id
      this.knowledgeId_id = item.knowledgeId; //知识id
      this.formLabelAlign.name = item.question; //问题
      this.createTime = item.createTime; //创建时间
      this.values = item.answer; //问题答案
      this.status = item.status; //问题状态
      // console.log(this.popoverVisible)

      if (
        item.similarQuestion == "" ||
        JSON.parse(item.similarQuestion) == null
      ) {
        this.dynamicValidateForm.domains = [];
      } else {
        console.log(JSON.parse(item.similarQuestion));
        this.dynamicValidateForm.domains = JSON.parse(item.similarQuestion);
        // for(let i =0 ;i<JSON.parse(row.similarQuestion).length;i++){

        //    this.questions_b.push(JSON.parse(row.similarQuestion)[i])
        //    this.questions_b.shift();
        // }

        // console.log(this.questions_b);
        // this.dynamicValidateForm.domains = this.questions_b;
        //  this.dynamicValidateForm.domains = JSON.parse(row.similarQuestion);
      }
      console.log(this.dynamicValidateForm.domains);
    },
    //删除知识
    handleDel(index, row) {
      console.log(index, row);
      api
        .delknowledge({
          knowlegeId: row.knowledgeId,
        })
        .then((res) => {
          if (res.code == "ok") {
            this.$message({
              message: this.$t("chat.successfullydelete"),
              type: "success",
            });
            this.tabclick();
          } else {
            this.$message.error(this.$t("chat.failtodelete"));
          }
        });
    },
    //删除分组
    handleDelete(index, row) {
      console.log(row);
      api
        .deleteShorcutGroup({
          groupId: row.groupId,
        })
        .then((res) => {
          if (res.code == "ok") {
            this.$message({
              message:this.$t("chat.successfullydelete"),
              type: "success",
            });
            this.getShortcutGroup();
          } else {
            this.$message.error(this.$t("chat.failtodelete"));
          }
        });
    },
    handleAdd(index, row) {
      console.log(index, row);
      this.issue = true;
      this.negative_id = row.groupId;
      this.value_grop = row.groupName;
    }, //打开添加问答
    addknowleged_close() {
      this.values = "";
      this.formLabelAlign.name = "";
      this.similarity = [];
      this.dynamicValidateForm.domains = [];
      this.issue = false;
       this.qestionvalue = '';   
    }, //关闭添加问答弹窗
    addknowleged_close_kj() {
      this.values = "";
      this.formLabelAlign.name = "";
      this.similarity = [];
      this.dynamicValidateForm.domains = [];
      this.issue_kj = false;
    },
    addnew() {
      this.issue = true;
      this.negative_id = this.tabName;
    },
    addknowleged() {
      console.log(JSON.stringify(this.dynamicValidateForm.domains));
      console.log(this.negative_id);
      console.log(JSON.stringify(this.similarity));
      if (this.values == "" || this.formLabelAlign.name == "") {
        this.$message({
          message: this.$t("chat.beempty"),
          type: "warning",
        });
      } else {
        api
          .addknowledge({
            answer: this.values,
            categoryId: this.negative_id,
            question: this.formLabelAlign.name,
            simlarQuestion: JSON.stringify(this.dynamicValidateForm.domains),
            userId: this.userId,
          })
          .then((res) => {
            if (res.code == "ok") {
              console.log(res);
              this.$message({
                message: this.$t("chat.successfullyadded"),
                type: "success",
              });
              // this.getShortcutGroup();
              this.tabclick();
              this.issue = false;
            } else {
              this.$message.error(this.$t("chat.additionfailed"));
            }
          });
      }

      this.values = "";
      this.formLabelAlign.name = "";
      this.similarity = [];
      this.dynamicValidateForm.domains = [];
       this.qestionvalue = '';   
    }, //添加问答
    addknowleged_kj() {
      console.log(this.shortcutGroup);
      api
        .addknowledge({
          answer: this.values,
          categoryId: this.shortcutGroup,
          question: this.formLabelAlign.name,
          simlarQuestion: JSON.stringify(this.dynamicValidateForm.domains),
          userId: this.userId,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.$message({
              message: this.$t("chat.successfullyadded"),
              type: "success",
            });
            // this.getShortcutGroup();
            this.tabclick_kj();
            this.tabclick();
          } else {
            this.$message.error(this.$t("chat.additionfailed"));
          }
        });
      this.values = "";
      this.formLabelAlign.name = "";
      this.similarity = [];
      this.dynamicValidateForm.domains = [];
      this.issue_kj = false;
    }, //快捷回复添加问答
    editknowleged_kj(){
        console.log(this.dynamicValidateForm.domains);
      // console.log(this.dynamicValidateForm.domains[0].value)
      // if(this.dynamicValidateForm.domains.length!=""){
      //     for(let i = 0 ;i<this.dynamicValidateForm.domains.length;i++){
      //       this.questions_o.push(this.dynamicValidateForm.domains[i].value);
      // }
      // console.log(this.questions_o)
      // }else{
      //   this.questions_o = null;
      // }

      let data = {
        answer: this.values,
        categoryId: this.negative_id,
        question: this.formLabelAlign.name,
        knowledgeId: this.knowledgeId_id,
        createTime: this.createTime,
        status: this.status,
        similarQuestion: JSON.stringify(this.dynamicValidateForm.domains),
        userId: this.userId,
      };
      let datatable = JSON.stringify(data);

      api
        .updateknowledge({
          documentString: datatable,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.$message({
              message: this.$t("chat.modifysuccessfully"),
              type: "success",
            });
            this.tabclick();
            this.tabclick_kj();
          } else {
            this.$message.error(this.$t("chat.changefailed"));
          }
        });
      this.values = "";
      this.formLabelAlign.name = "";
      this.amend_kj = false;
      this.questions_o = [];
      this.questions_b = [{ value: "" }];
      this.dynamicValidateForm.domains = [];
    },//快捷回复修改回答
    editknowleged() {
      console.log(this.dynamicValidateForm.domains);
      // console.log(this.dynamicValidateForm.domains[0].value)
      // if(this.dynamicValidateForm.domains.length!=""){
      //     for(let i = 0 ;i<this.dynamicValidateForm.domains.length;i++){
      //       this.questions_o.push(this.dynamicValidateForm.domains[i].value);
      // }
      // console.log(this.questions_o)
      // }else{
      //   this.questions_o = null;
      // }

      let data = {
        answer: this.values,
        categoryId: this.negative_id,
        question: this.formLabelAlign.name,
        knowledgeId: this.knowledgeId_id,
        createTime: this.createTime,
        status: this.status,
        similarQuestion: JSON.stringify(this.dynamicValidateForm.domains),
        userId: this.userId,
      };
      let datatable = JSON.stringify(data);

      api
        .updateknowledge({
          documentString: datatable,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.$message({
              message: this.$t("chat.modifysuccessfully"),
              type: "success",
            });
            this.tabclick();
          } else {
            this.$message.error(this.$t("chat.changefailed"));
          }
        });
      this.values = "";
      this.formLabelAlign.name = "";
      this.amend = false;
      this.questions_o = [];
      this.questions_b = [{ value: "" }];
      this.dynamicValidateForm.domains = [];
    }, //修改问答
    closeamend() {
      this.values = "";
      this.formLabelAlign.name = "";
      this.amend = false;
      this.questions_o = [];
      this.dynamicValidateForm.domains = [];
    },
    closeamend_kj(){
      this.values = "";
      this.formLabelAlign.name = "";
      this.amend_kj = false;
      this.questions_o = [];
      this.dynamicValidateForm.domains = [];
    },
    //开关按钮
    change(index, row) {
      console.log(index, row);
    },
    //关闭添加问题对话框
    handleClose(done) {
      this.$confirm(this.$t("chat.Confirmtoclose"))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose_grop(){
      this.addnewgrop = false;
    },
    handleClose_hint(){
      this.custom_hint = false;
    },
    //选择分类
    handleChange(value) {
      console.log(value);
    },
    //删除问题
    removeDomain(item) {
      console.log(item);
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    //增加问题
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: "",
      });
    },

    addDomains() {
      this.similarity.push({
        value: "",
      });
    },

    addTab(targetName) {
      let newTabName = ++this.tabIndex + "";
      this.editableTabs.push({
        title: "答案" + newTabName,
        name: newTabName,
        content: "",
      });
      this.editableTabsValue = newTabName;
      console.log(this.editableTabsValue);
    }, //增加答案选项
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    }, //删除答案选项
    demo() {
      console.log(this.stringToJson(this.conversationHistory[0]));
    },

    translateAllConversationHistory(toLanguage){
      for(var index in this.conversationHistory){
        if(this.conversationHistory[index].content!=''&&this.conversationHistory[index].messageType=='text'&&this.conversationHistory[index].content!=null){
          this.translation(this.conversationHistory[index],index,toLanguage,this.conversationHistory[index].messageId)
        }
      }
    },







    addGroup() {
      api
        .addGroup({
          groupName: this.groupName,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.$message({
              message: this.$t("chat.successfullyadded"),
              type: "success",
            });
            this.getShortcutGroup();
          } else {
            this.$message.error(this.$t("chat.additionfailed"));
          }
        });
    },
    removeShortcutTab(targetName) {
      api
        .deleteShorcutGroup({
          groupId: targetName,
        })
        .then((res) => {
          console.log(res);
          this.getShortcutGroup();
        });
    },
    confirmModifyGroup(item) {
      console.log(item);
      if (this.modifyGroupName != "") {
        api
          .updateShortcutGroup({
            groupId: item.groupId,
            groupName: this.modifyGroupName,
          })
          .then((res) => {
            console.log(res);
            this.modifyGroup = true;
            this.modifyGroupName = "";
            this.getShortcutGroup();
          });
      } else {
        this.$message.warning(this.$t("chat.Pleaseenterandmodify"));
      }
    },
    modifyMessage(item_, index_) {
      api
        .updateShortcutMessage({
          content: this.modifyMessage_,
          shortcutMessageId: item_.shortcutMessageId,
        })
        .then((res) => {
          console.log(res);
          this.ifModifyMessageIndex = null;
          this.getShortcutMessage();
        });
    },
    deleteMessage(item) {
      console.log(item);
      api
        .delknowledge({
          knowlegeId: item.knowledgeId,
        })
        .then((res) => {
          if (res.code == "ok") {
            this.$message({
              message: this.$t("chat.successfullydelete"),
              type: "success",
            });
            this.tabclick_kj();
          } else {
            this.$message.error(this.$t("chat.changefailed"));
          }
        });
    },
    ifaddShortcutMessage_() {
      // this.showInput = this.showInput ? false : true;
      // this.shortcutMessage = "";
      this.issue_kj = true;
    },

    // 获取某会话所有的聊天记录
    async getAllConversationHistory(item, index) {
      console.log(item);

      this.conversationData = item;
      this.selects = index;
      this.toAvatar = item.toAvatar;
      // console.log(this.toAvatar);
      // console.log(22222222)
      // this.stacontent = item.content;
      // console.log(this.stacontent);
      this.orderLoading = true;
      await this.getConversationAllHistory_();
      await this.getConversation(this.conversationHistoryParams);
      this.$nextTick(() => {
        this.talkPanelScrollBottom();
      });
    },
    // 获取某会话所有的聊天记录
    getConversationAllHistory_() {
      console.log(454545);
      console.log(this.select);
      console.log(this.shopId);

      api
        .getConversationAllHistory({
          conversationId: this.conversationData.conversationId,
          pageNum: 1,
          pageSize: 10,
          shopId: this.shopId,
        })
        .then((res) => {
          console.log(res);
          console.log(res.messages.length);
          this.conversationHistoryParams = {
            conversationId: this.conversationData.conversationId,
            pageNum: 1,
            pageSize: res.messages.length,
            shopId: this.shopId,
          };
          console.log(this.conversationHistoryParams);
          api
            .getBuyerOrder({
              buyerUserName: this.conversationData.toName,
              shopId: this.shopId,
              orderStatus: "ALL",
            })
            .then((res) => {
              console.log(11111111);
              console.log(res);
              this.orderData = res.orders;

              console.log(this.add_remark);
              console.log(22222);
              console.log(res.orders);
              this.orderLoading = false;
            });
        });
    },

    changepover() {
      this.modifyGroup = true
      console.log(this.popoverVisible)
      if(this.popoverVisible==true){
        this.popoverVisible = false
      }else{
        this.popoverVisible = true
      }
      

      
     
      (this.modifyGroupName = ""),
        (this.modifyMessage_ = ""),
        (this.ifModifyMessageIndex = null),
        (this.showInput = false);
      this.shortcutMessage = "";
      this.shortcutGroup = this.shortcutGroupData[0].groupId;
      this.tabclick_kj();
    },
    closepov(){
      this.popoverVisible = false
    },

    //在某个分组下添加快捷短信模板
    addShortcutMessage() {
      api
        .getAddShortCutMessage({
          content: this.shortcutMessage,
          groupId: this.shortcutGroup,
        })
        .then((res) => {
          console.log(res);
          this.getShortcutMessage();
        });
      this.showInput = false;
    },

    //获取用户所有的分组
    getShortcutGroup() {
      api
        .getShortcutGroup({
          userId: this.userId, //用户id
        })
        .then((res) => {
          console.log(res);
          this.shortcutGroupData = res.groups;
          console.log(res.groups);
          if(res.groups.length!=0){
            this.shortcutGroup = res.groups[0].groupId;

          this.optionso = res.groups;
          this.tabName = res.groups[0].groupId;
          console.log(this.optionso);
          this.getShortcutMessage();
          this.tabclick();
          }
          
        });
    },

    // 获取某一分组下所有的快捷短信模板
    getShortcutMessage() {
      api
        .getShortcutMessage({
          groupId: this.shortcutGroup,
        })
        .then((res) => {
          // this.shortcutMessageData = res.shortcutMessages;
        });
    },

    //将string转换成json
    stringToJson(str) {
      return eval("(" + str + ")");
    },

    // 将转换成2021-05-11,22:48格式
    stringTime(time) {
      var date = new Date(parseInt(time) * 1000);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d + "," + date.toString().slice(-26, -21);
    },

    //搜索用户，短信
    search_() {
      console.log(this.select);
      switch (this.select) {
        case "-1":
          this.searchMessage_ = true;
          this.getConversationList(this.filters);
          console.log(this.searchMessage_);
          this.search_text = this.$t("chat.Allthequery");
          break;
        case "0":
          this.searchFilters.pageSize = 10;
          (this.searchFilters.queryType = 0),
            (this.searchFilters.shopId = this.shopId);
          this.searchFilters.userId = this.userId;
          this.searchMessage(this.searchFilters);
          this.searchMessage_ = false;
          console.log(this.searchMessage_);
          this.search_text = this.$t("chat.Querymessage");
          break;
        case "1":
          this.searchFilters.pageSize = 10;
          (this.searchFilters.queryType = 1),
            (this.searchFilters.shopId = this.shopId);
          this.searchFilters.userId = this.userId;
          this.searchMessage(this.searchFilters);
          this.searchMessage_ = true;
          this.search_text = this.$t("chat.QueryingCustomername");
          break;
        default:
          break;
      }
    },

    // 搜索用户名以及消息（搜索消息还没弄好，返回的数据与其他的不同需要，还需要处理一下；定位消息获取消息元素位置并跳转还没弄好）
    async searchMessage(params) {
      api.searchMessage(params).then((res) => {
        switch (this.searchFilters.queryType) {
          case 0:
            clearInterval(this.unread);
            console.log(res.content);
            this.changeColor(res.content);
            break;
          case 1:
            console.log(res.content[0]);
            this.conversationList = res.content[0];
            console.log(res.content);

            break;
          default:
            break;
        }
      });
    },
    //关键字高亮
    changeColor(resultsList) {
      // console.log(this.conversationList);
      // console.log(5555555);
      // console.log(this.searchFilters.queryString);
      // console.log(resultsList);
      // console.log(resultsList[0].hitMessage);
      resultsList.map((item, index) => {
        // console.log('item', item.hitMessage);
        // console.log(resultsList[index].hitMessage);
        if (
          this.searchFilters.queryString &&
          this.searchFilters.queryString.length > 0
        ) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.searchFilters.queryString, "g");
          // 高亮替换v-html值
          let replaceString =
            '<span style="color: #2D7BFF">' +
            this.searchFilters.queryString +
            "</span>";

          resultsList[index].hitMessage = item.hitMessage.replace(
            replaceReg,
            replaceString
          );
        }
      });
      this.conversationList = [];
      this.conversationList = resultsList;
    },

    //粘贴图片到输入框中
    pasting(e) {
      if (e.clipboardData.files[0] != undefined) {
        this.uploadFile(e.clipboardData.files[0]);
      } else {
        this.textarea = e.clipboardData.getData("Text");
      }
    },

    submit() {
      this.$refs.upload.submit();
    },



    // 获取已被授权的页面并设置定时器获取每个店铺是否有未读消息
    getShopList() {
      var queryData;
      var authorizedShopList = [];
      api
        .getAuthorizedShopList({
          pageNum: 1,
          pageSize: 100,
          userId: this.userId,
        })
        .then((res) => {
          console.log(res)
          // console.log("==========")
          this.processData(res)
          // this.getstore();
          this.authorizedShopList = res.pageInfo.list;
          if (this.authorizedShopList[0]==undefined) {
            this.tab = false
          }else{
            this.enter(this.authorizedShopList[0])
            // this.synchronously();
          }
          
          // this.unread = setInterval(() => {
          //   setTimeout(() => {
          //   if (this.searchFilters.queryType != 1) {
          //     this.getConversationList(this.filters);
          //     if(this.conversationData.unreadCount!=0){
          //        this.getConversation(this.conversationHistoryParams);
          //     }
             
          //   }
          //   }, 0);
          // }, 60000);


        });
    },
    handleShopClick(data){
      console.log(data)
      if(data.children==undefined){
        this.enter(data);
        
        console.log("=======")
      }
    },
    processData(res){
      var data = []
      var json
      var index = 0
      for(var key in res.shopsGroupByRegion){
        json = {
          region:this.countryName[key],
          label:this.countryName[key],
          children:[] 
        }
        data.push(json)
        for(var i in res.shopsGroupByRegion[key]){
          data[index].children.push(res.shopsGroupByRegion[key][i])
          data[index].children[i].label = res.shopsGroupByRegion[key][i].shopName
        }
        index++
      }
      console.log(data)
      this.shopsGroupByRegion = data
      console.log("======================================")

    },

    //会话栏的触底加载
    async talkConcersationScroll(e) {
      var height = e.target.scrollHeight - 539;
      if (e.target.scrollTop > height) {
        this.filters.pageSize = this.filters.pageSize + 10;

        if (this.select == "-1") {
          await this.getConversationList(this.filters);
        } else {
          this.searchFilters.pageSize = this.searchFilters.pageSize + 10;
          await this.searchMessage(this.searchFilters);
        }
      }
    },

    async talkMessageScroll(e) {
      var height = e.target.scrollHeight - 539;
      if (e.target.scrollTop > height) {
        this.searchFilters.pageSize = this.searchFilters.pageSize + 10;
        this.searchMessage(this.searchFilters);
      }
    },

    // 聊天记录的触顶加载
    async talkPanelScroll(e) {
     try {
      if (e.target.scrollTop == 0) {
        this.conversationHistoryParams.pageSize =
        this.conversationHistoryParams.pageSize + 10;
        await this.getConversation(this.conversationHistoryParams);
         var height = e.target.scrollHeight;
        var height_ = e.target.scrollHeight;
        let el = document.getElementById("scrolldIV");
        el.scrollTop = height_ - height;
      }
     } catch (error) {
       console.log('pagesize为null')
     }

    },
    tarcn(e){
      console.log(e);
      api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: e.content,
            toLanguage: 'zh-cn',
            messageId:e.messageId
          })
          .then((res) => {
            if(res.code=='ok'){
               e.content = res.translation;
            }else if(res.code=='failed'){
              this.$message({
          message: res.msg,
          type: 'warning'
        });
        
            }
           
          });
    },//翻译为中文
    taren(e){
        console.log(e);
      api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: e.content,
            toLanguage: 'en',
            messageId:e.messageId
          })
          .then((res) => {
            
           if(res.code=='ok'){
               e.content = res.translation;
            }else if(res.code=='failed'){
              this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
          });
    },//翻译为英文
    //跳转聊天底部
    talkPanelScrollBottom() {
      let el = document.getElementById("scrolldIV");
      el.scrollTop = el.scrollHeight;
    },
    translate() {
      console.log(this.languages);
      this.btn_fy = 2;
      console.log(this.btn_fy);
      switch (this.languages) {
        case "1":
          this.sendTranslate("en"); //翻译为英文
          break;
        case "2":
          this.sendTranslate("th"); //翻译为泰文
          break;
        case "3":
          this.sendTranslate("ms"); //翻译为马来文
          break;
          case "4":
          this.sendTranslate("zh-cn"); //翻译为中文
          break;
        case "5":
          this.sendTranslate("vi"); //翻译为中文
          break;
        case "6":
          this.sendTranslate("id"); //翻译为中文
          break;
        case "7":
          this.sendTranslate("es"); //翻译为中文
          break;
        case "8":
          this.sendTranslate("pt"); //翻译为中文
          break;
        // case "4":
        //   this.sendTranslate(""); //翻译为原文
        //   break;

        default:
          break;
      }
    }, //翻译按钮
    translates() {
      this.btn_fy = 1;
      
      this.sendTranslate(""); //翻译为原文
    }, //翻译回原文
    
    changblur() {
      this.sendInit = this.textarea;
      
      // console.log(this.sendInit)
    }, //实时更新输入框内容
    changein(){
      if(this.textarea==''){
        this.btn_fy = 1;
      }
    },
    // changinput(){
      
    //   if(this.checked == true){
    //     console.log(this.checked);
    //   console.log(this.textarea);
    //   this.sendInit = this.textarea;
    //   console.log(this.sendInit);
    //       console.log(this.languages);
    //   // this.btn_fy = 2;
    //   console.log(this.btn_fy);
    //   switch (this.languages) {
    //     case "1":
    //       this.sendTranslate("en"); //翻译为英文
    //       break;
    //     case "2":
    //       this.sendTranslate("th"); //翻译为泰文
    //       break;
    //     case "3":
    //       this.sendTranslate("ms"); //翻译为马来文
    //       break;
    //     case "4":
    //       this.sendTranslate(""); //翻译为原文
    //       break;

    //     default:
    //       break;
    //   }
    //   }
    // },//实时翻译
    // 翻译当前输入框的文字为指定内容
    sendTranslate(toLanguage) {
      console.log(this.sendInit);
      this.toLanguage = toLanguage;
      console.log(this.toLanguage);
      if (toLanguage == "") {
        this.textarea = this.sendInit;
      } else {
        api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: this.textarea,
            toLanguage: toLanguage,
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              if (this.sendInit == "") {
              this.sendInit = this.textarea;
            }
            this.textarea = res.translation;
            }else if(res.code=='failed'){
              this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
            
          });
      }
    },

    // 获取当前年月
    getToday() {
      function completeDate(value) {
        return value < 10 ? "0" + value : value;
      }
      var char = "-";
      var nowDate = new Date();
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + completeDate(month) + char + completeDate(day);
    },

    //打开授权页面
    authorizes() {
      console.log(this.userId);
      window.open("https://erp.shopsbu.com/cus/authorize/url/get?userId="+this.userId, "_blank");
    },

    echart() {
      //获取echart显示区域
      // var chartsline= echarts.init(this.$refs['echart1']);
      // var options = this.options
      // // 将options导入echart
      // chartsline.setOption(options,true)
    },
    //快捷发送消息
    keyDown(e){
      if(e.keyCode==13){
        this.send();
      }
    },
    //发送消息
    send() {
      if (this.textarea != "") {
        api
          .sendMessage({
            content: this.textarea,
            conversationId: this.conversationData.conversationId,
            fromId: this.fromId,
            messageType: "text",
            shopId: this.shopId,
            toId: this.toId,
            toShopId: this.toShopId,
          })
          .then((res) => {
            console.log(res);
            if (res.code == "ok") {
              this.textarea = "";
              this.sendamessage(this.conversationData,this.selects);
              remind
                    .answerbehavi({
                      answer :res.message.content,
                      answerType :this.answerType,
                      matchMessageId :this.matchMessageId,
                      messageId :res.message.messageId,
                      shopId : this.shopId,
                      userId : this.userId
                    })
                    .then((res) => {
                      console.log('记录客服消息发送记录');
                      console.log(res);
                      this.answerType = 'MANUAL_INPUT';
                      this.matchMessageId='';
                    });
            }else if(res.code=='failed'){
                this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
          });
      } else {
      }
    },
    // 发送商品信息
    Sendgoods(e) {
      console.log(e.order_sn);
      api
        .insertMessage({
          content: e.order_sn,
          conversationId: this.conversationData.conversationId,
          fromId: this.fromId,
          messageType: "order",
          shopId: this.shopId,
          toId: this.toId,
          toShopId: this.toShopId,
        })
        .then((res) => {
          if (res.code == "ok") {
            console.log(res);
            this.$notify({
              title:  this.$t("chat.succeed"),
              message:this.$t("chat.sentsuccessfully"),
              type: "success",
            });
            this.conversation(this.conversationData);
            // this.getConversationAllHistory_();
            // this.textarea = "";
            // this.conversation(this.conversationData);
          }
        });
    },

    async sendamessage(item, index){
       this.conversationData = item;
      this.selects = index;
      this.toAvatar = item.toAvatar;
      // this.orderLoading = true;
      this.conversationHistoryParams = {
        conversationId: this.conversationData.conversationId,
        pageNum: 1,
        pageSize: 10,
        shopId: this.shopId,
      };
      // this.getcustommessage();//获取某个店铺的自定义回复
      // this.getrepones();
      // this.user_portrayal(); //获取某个买家的画像
      // this.getusergroup_ck();//获取当前买家的分组
      // this.getstore();
      // api
      //   .getBuyerOrder({
      //     buyerUserName: this.conversationData.toName,
      //     shopId: this.shopId,
      //     orderStatus: "ALL",
      //   })
      //   .then((res) => {
      //     this.orderData = res.orders;
      //     if(res.orders !=''){
      //         console.log(res.orders[0].region);
      //         this.country = res.orders[0].region
      //     }
          
      //     console.log(this.orderData);
      //     // console.log(this.orderData[0].note);
      //     // this.add_remark =JSON.stringify(res.orders.note) ;///备注消息
      //     this.orderLoading = false;
      //   });
        
      await this.getConversation(this.conversationHistoryParams);
      // this.orderLoading = true;
      //  if(item.isRead == 0){
      //        this.getUserNewMessage();
      // }
      //  this.getUserNewMessage();
      this.$nextTick(() => {
        this.talkPanelScrollBottom(); 

      });
    },
    //获取会话列表以及订单信息
    async conversation(item, index) {
      this.conversationData = item;
      this.selects = index;
      this.toAvatar = item.toAvatar;
      this.orderLoading = true;
      this.conversationHistoryParams = {
        conversationId: this.conversationData.conversationId,
        pageNum: 1,
        pageSize: 10,
        shopId: this.shopId,
      };
      // this.getcustommessage();//获取某个店铺的自定义回复
      this.getrepones();
      this.user_portrayal(); //获取某个买家的画像
      this.getusergroup_ck();//获取当前买家的分组
      // this.getstore();//获取店铺是否开启了自动翻译
      api
        .getBuyerOrder({
          buyerUserName: this.conversationData.toName,
          shopId: this.shopId,
          orderStatus: "ALL",
        })
        .then((res) => {
          this.orderData = res.orders;
          if(res.orders !=''){
              console.log(res.orders[0].region);
              this.country = res.orders[0].region
          }
          
          console.log(this.orderData);
          // console.log(this.orderData[0].note);
          // this.add_remark =JSON.stringify(res.orders.note) ;///备注消息
          this.orderLoading = false;
        });
        
      await this.getConversation(this.conversationHistoryParams);
      //  if(item.isRead == 0){
      //        this.getUserNewMessage();
      // }
       this.getUserNewMessage();
      this.$nextTick(() => {
        this.talkPanelScrollBottom(); 
      });
    },
    //关键字高亮
    changeColorH(resultsList) {
      // console.log(this.conversationList);
      // console.log(5555555);
      // console.log(this.searchFilters.queryString);
      // console.log(resultsList);
      // console.log(resultsList[0].hitMessage);
      resultsList.map((item, index) => {
        // console.log('item', item.hitMessage);
        // console.log(resultsList[index].hitMessage);
        if (
          this.searchFilters.queryString &&
          this.searchFilters.queryString.length > 0
        ) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.searchFilters.queryString, "g");
          // 高亮替换v-html值
          let replaceString =
            '<span style="color: #ff0000" id="text">' +
            this.searchFilters.queryString +
            "</span>";

          resultsList[index].content = item.content.replace(
            replaceReg,
            replaceString
          );
        }
      });
      this.conversationHistory = [];
      this.conversationHistory = resultsList;
    },

    //api获取聊天记录并处理数据
    async getConversation(params) {
      
      this.chatLoading = true;
      await api.getConversationHistory(params).then((res) => {
        var arr = res.messages;
        console.log(res.messages);

        console.log(this.stacontent)
        this.changeColorH(res.messages);
        var date = this.getToday();

        function unshiftConversationHistory(arr) {
          var conversationHistory = [];
          for (var index in arr) {
            conversationHistory.unshift(arr[index]);
          }
          return conversationHistory;
        }

        this.conversationHistory = unshiftConversationHistory(arr);

        
      //  this.getUserNewMessage();//接受到用户的最新消息，进行消息命中匹配
        this.checkchang();//动态翻译
        // if(this.conversationHistory[0].toShopId != this.toShopId && this.conversationHistory[0].messageType=='text'  && this.conversationHistory[0].content != null && this.conversationHistory[0].content != ''){
        //   console.log(this.conversationHistory[0].content);
        //   api
        //   .matchknowledge({
        //     question : this.conversationHistory[0].content,
        //     userId : this.userId
        //   })
        //   .then((res) => {
        //     console.log('回答');
        //     console.log(res);
        //   });//获取最新聊天记录命中得回答
        // }

        for (var index in this.conversationHistory) {
          if (
            this.conversationHistory[index].createdTime.slice(0, 10) == date
          ) {
            this.conversationHistory[index].time =
              "Today " +
              this.conversationHistory[index].createdTime.slice(11, 19);
          } else {
            this.conversationHistory[index].time = this.conversationHistory[
              index
            ].createdTime.slice(0, 19);
          }

          this.conversationHistory[index].toLanguage = "";
        }

        for(var index in this.conversationHistory){
            if(this.conversationHistory[index].messageType == 'sticker'){
          this.stacontent = this.conversationHistory[index].content;
              // var str = this.stacontent.split(",");
          
              // var det = str[0];
              console.log(this.stacontent);
                // console.log(det)
          this.conversationHistory[index].content = this.sticker_img[this.stacontent];
          // console.log(this.conversationHistory[index].content)
        }
        }//发送图片替换

        
        
        if (this.conversationHistory[0].fromShopId == this.shopId) {
          this.fromId = this.conversationHistory[0].fromId;
          this.toId = this.conversationHistory[0].toId;
          this.toShopId = this.conversationHistory[0].toShopId;
        } else if (this.conversationHistory[0].toShopId == this.shopId) {
          this.fromId = this.conversationHistory[0].toId;
          this.toId = this.conversationHistory[0].fromId;
          this.toShopId = this.conversationHistory[0].fromShopId;
        }
        
        api
          .readConversation({
            conversationId: this.conversationData.conversationId,
            isRead: 1,
            shopId: this.shopId,
          })
          .then((res) => {
            this.chatLoading = false;
            this.getConversationList(this.filters);
          });
        
         
          
        
        

        this.$nextTick(() => {
          console.log(document.getElementById("text"));
          if (document.getElementById("text") && this.scorllstatus) {
            console.log(
              document.getElementById("text").parentNode.parentNode.parentNode
                .parentNode.parentNode.parentNode.parentNode
            );
            console.log(
              document.getElementById("text").parentNode.parentNode.parentNode
                .parentNode.parentNode.parentNode.parentNode.offsetTop
            );

            document.getElementById("scrolldIV").scrollTop =
              document.getElementById("text").parentNode.parentNode.parentNode
                .parentNode.parentNode.parentNode.parentNode.offsetTop - 100;
            this.scorllstatus = false;
          }
        });
      });
    },

    getUserNewMessage(){
      var lastMessage = ''
      console.log(this.conversationHistory)
      for(var index in this.conversationHistory){
        if(this.conversationHistory[index].fromShopId!=this.shopId&&this.conversationHistory[index].messageType=='text'){
          lastMessage = this.conversationHistory[index]
        }
      }
      console.log(lastMessage.content);
      remind
          .getanswer({
            
            conversationId : this.conversationData.conversationId,
            // question : lastMessage.content,
            shopId :this.shopId,
            userId : this.userId
          })
          .then((res) => {
            console.log('回答');
            console.log(res);
           
            if(res.code == 'ok'){
              if(res.replyList!=""){
                 this.answerRecommend =res.replyObject;
                 for(let i =0;i<3;i++){
                   if(res.replyObject[i] == null){
                     return
                   }else{
                     this.answerthree.push(res.replyObject[i]);
                   }
                   
                 }
                 console.log(this.answerthree);
                for(var index in this.answerthree){
                  switch (this.voluntarily) {
                        case "1":
                             this.recommendanswer(this.answerthree[index],index,'en');
                            // this.updatelange('en');
                          break;
                        case "2":
                             this.recommendanswer(this.answerthree[index],index,'th');
                            // this.updatelange('th','1');
                          break;
                        case "3":
                             this.recommendanswer(this.answerthree[index],index,'ms');
                            // this.updatelange('ms','1');
                          break;
                        case "4":
                            this.recommendanswer(this.answerthree[index],index,'zh-CN');
                            // this.updatelange('zh-cn','1');
                          break;
                        case "5":
                             this.recommendanswer(this.answerthree[index],index,'vi');
                            // this.updatelange('vi','1');
                          break;
                        case "6":
                             this.recommendanswer(this.answerthree[index],index,'id');
                            // this.updatelange('id','1');
                          break;
                        case "7":
                             this.recommendanswer(this.answerthree[index],index,'es');
                            // this.updatelange('es','1');
                          break;
                        case "8":
                             this.recommendanswer(this.answerthree[index],index,'pt');
                            // this.updatelange('pt','1');
                          break;
                        
                        default:
                          break;
                      }
                  
                }
                //  translation(item, index, '',item.messageId)
                 this.pitch = true;
                 setTimeout(() => {
              this.pitch = false;
              this.answerthree = [];
            }, 4000);
          
            console.log('机器智能回复');
            console.log(this.answerRecommend);
              }else{
                this.answerRecommend = [];
                console.log('未匹配')
              }
            //   if(res.hitted !=""){
            //     this.gridData = res.hitted;
            //     this.pitch = true;
            //   }else{
            //     this.gridData = [];
            //   }
            //    if(res.similar != ""){
            //     this.similarData = res.similar;
            //      this.pitch = true;
            //   }else{
            //     this.similarData = [];
            //   }
              
              
             
              
                  
            }
            
          });//获取最新聊天记录命中得回答
        
      
    },

    uploadFile_(e) {
      console.log(e);
      this.uploadFile(e.file);
    },

    uploadFile(file) {
      let formdata = new FormData();
      formdata.append("photo", file);
      formdata.append("shopId", this.shopId);
      const h = this.$createElement;
      axios
        .post("https://erp.shopsbu.com/cus/message/upload", formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            this.dialogVisible = true;
            this.sendImgUrl = res.data.photoUrl.url;
          } else {
            this.$message.error(this.$t("chat.Failepicture"));
          }
        });
    },

    //发送图片
    sendImg(e) {
      if (e) {
        api
          .sendMessage({
            content: this.sendImgUrl,
            conversationId: this.conversationData.conversationId,
            fromId: this.fromId,
            messageType: "image",
            shopId: this.shopId,
            toId: this.toId,
            toShopId: this.toShopId,
          })
          .then((res) => {
            if (res.code == "ok") {
              this.sendImgUrl = "";
              this.dialogVisible = false;
              this.conversation(this.conversationData);
            } else {
              this.$message.error(this.$t("chat.Failepicture"));
            }
          });
      } else {
        this.$message.error(this.$t("chat.Cancelledsend"));
        this.dialogVisible = false;
      }
    },
     handleCommand_fy(command) {
        console.log(command);
        if(command == 'a'){
          console.log(this.formLabelAlign.name)
          this.sendTranslate_fy('en',this.formLabelAlign.name)
        }else if(command == 'b'){
          this.sendTranslate_fy('th',this.formLabelAlign.name)
        }else if (command == 'c'){
          this.sendTranslate_fy('ms',this.formLabelAlign.name)
        }
      },
      handleCommand_da(command){
        console.log(command);
        if(command == 1){
          
          this.sendTranslate_da('en',this.values)
        }else if(command == 2){
          this.sendTranslate_da('th',this.values)
        }else if (command == 3){
          this.sendTranslate_da('ms',this.values)
        }
      },
      handleCommand_xs(domain){
       
        console.log(domain);
        if(this.command_value == 1){
          api
          .translation({
            text: domain.value,
            toLanguage: 'en',
             shopId : this.shopId,
            userId : this.userId,
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              domain.value = res.translation;
            }else if(res.code=='failed'){
              this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
            
          });
        } 
      
        
      },
      checkcommond(){
        console.log(this.command_value);
      },
      getusergroup_ck(){
         remind
        .getusergroup({
         
          consumerName : this.conversationData.toName,
          userId  : this.userId 
          
        })
        .then((res) => {
          console.log('买家分组')
          this.tags = res.categories;
          console.log(this.tags);
        });
      },//获取当前买家的分组
    //   sendTranslate_xs(toLanguage,input_text) {
      
    //     api
    //       .translation({
    //         text: input_text,
    //         toLanguage: toLanguage,
    //       })
    //       .then((res) => {
            
    //         this.domain.value =res.translation;
    //       });
      
    // },
      sendTranslate_fy(toLanguage,input_text) {
      // console.log(this.sendInit);
      // this.toLanguage = toLanguage;
      // console.log(this.toLanguage);
      
        api
          .translation({
            shopId : this.shopId,
            userId : this.userId,
            text: input_text,
            toLanguage: toLanguage,
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              this.formLabelAlign.name = res.translation;
            }else if(res.code=='failed'){
               this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
            
          });
      
    },
    sendTranslate_da(toLanguage,input_text) {
      // console.log(this.sendInit);
      // this.toLanguage = toLanguage;
      // console.log(this.toLanguage);
      
        api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: input_text,
            toLanguage: toLanguage,
            messageId:'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              this.values = res.translation;
            }else if(res.code=='failed'){
               this.$message({
          message: res.msg,
          type: 'warning'
        });
            }
            
          });
      
    },
    //未读消息，标记 的选择
    handleCommand(command) {
      this.filters.shopId = this.shopId;
      switch (command) {
        case "0":
          this.filters.isRead = 0;
          if (this.pageSize_ == null) {
            this.pageSize_ = this.filters.pageSize;
          }
          this.filters.pageSize = 2000;
          break;
        case "true":
          this.filters.pinned = true;
          if (this.pageSize_ == null) {
            this.pageSize_ = this.filters.pageSize;
          }
          this.filters.pageSize = 2000;
          break;
        case "1":
          delete this.filters.isRead;
          this.filters.pageSize = this.pageSize_;
          this.pageSize_ == null;
          break;
        case "false":
          delete this.filters.pinned;
          this.filters.pageSize = this.pageSize_;
          this.pageSize_ == null;

          break;
        default:
          break;
      }
      this.getConversationList(this.filters);
    },

    //返回上一层注销定时器
    goBack() {
      if (this.select == "-1") {
        this.tab = false;
        this.shopId = null;
        this.select = "-1";
        this.searchFilters.queryString = "";
        this.conversationHistory = null;
        this.filters = {
          pageNum: 1,
          pageSize: 10,
        };
      } else {
        this.select = "-1";
        this.searchFilters.queryString = "";
        this.conversationHistory = null;
        this.filters = {
          pageNum: 1,
          pageSize: 10,
          shopId: this.shopId,
        };
        this.getConversationList(this.filters);
      }
      clearInterval(this.unread);
    },

    // 获取会话列表并处理时间
    async getConversationList(params) {
      await api.getShopConversationList(params).then((res) => {
        this.conversationList = res.conversations;
        this.conversationList_ = res.conversations;
        for (var index in this.conversationList) {
          this.conversationList[index].time = this.getConversationsTime(
            this.conversationList[index].lastMessageTimestamp
          );
        }
        // 
      });
    },

    //当天的消息返回具体时间，非当天的消息返回年月日
    getConversationsTime(time) {
      var date = this.getToday();
      if (time.slice(0, 10) == date) {
        return time.slice(11, 19);
      } else {
        return time.slice(0, 10);
      }
    },

    //进入某一商店的聊天中
    async enter(item) {
      this.tab = true;
      this.shopId = item.shopId;
      this.shopName = item.shopName;
      let params = {
        pageNum: 1,
        pageSize: 15,
        shopId: this.shopId,
      };
      this.filters.shopId = item.shopId;
      this.getstore();
      
      this.getcustommessage();//获取某个店铺的自定义回复
      await this.getConversationList(params);
      this.conversation(this.conversationList[0],0)
      this.examineshop();
      // this.synchronously();//会话同步
      
    },
    //翻译推荐回复
    recommendanswer(item, index, toLanguage){
      
         api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: item.answer,
            toLanguage: toLanguage,
            messageId: 'unknown'
          })
          .then((res) => {
            if(res.code=='ok'){
              
            this.answerthree[index].answer = res.translation;
            }else if(res.code=='failed'){
        //       this.$message({
        //   message: res.msg,
        //   type: 'warning'
        // });
        // this.checked = false;
        //  this.updatestore('0');
            }

          });
    },
    //聊天记录翻译
    translation(item, index, toLanguage,messageId) {
      if (toLanguage == "") {
        this.conversationHistory[index].content = this.conversationHistory[
          index
        ].content_;
        this.conversationHistory[index].toLanguage = toLanguage
        delete this.conversationHistory[index].content_
      } else {
        this.conversationHistory[index].toLanguage = toLanguage;
        api
          .translation({
             shopId : this.shopId,
            userId : this.userId,
            text: item.content,
            toLanguage: toLanguage,
            messageId: messageId
          })
          .then((res) => {
            if(res.code=='ok'){
              if (this.conversationHistory[index].content_ == undefined) {
              this.conversationHistory[
                index
              ].content_ = this.conversationHistory[index].content;
            }
            this.conversationHistory[index].content = res.translation;
            }else if(res.code=='failed'){
        //       this.$message({
        //   message: res.msg,
        //   type: 'warning'
        // });
        // this.checked = false;
        //  this.updatestore('0');
            }

          });
      }
    },

    // 删除会话
    deleteConversation(item) {
      api
        .deleteConversation({
          conversationId: item.conversationId,
          shopId: this.shopId,
        })
        .then((res) => {
          console.log(res);
          this.getConversationList(this.filters);
        });
    },





    //会话列表右键菜单
    talkItemsMenu(item, event) {
      let items = {
        items: [
          {
            label: this.$t("chat.stick"),
            icon:
              item.pinned == "false" ? "el-icon-star-off" : "el-icon-star-on",
              
            onClick: () => {
              this.pinned(item);
            },
          },
          {
            label: this.$t("chat.Setasunread"),
            icon: "el-icon-chat-dot-square",
            onClick: () => {
              this.markUnread(item);
            },
          },
          {
            label: this.$t("chat.Deletethesession"),
            icon: "el-icon-delete",
            onClick: () => {
              this.deleteConversation(item);
            },
          },
        ],
        event: event,
        zIndex: 10000,
      };
      this.$contextmenu(items);
      return false;
    },

    // 标记某一会话未读
    markUnread(item) {
      console.log(item);
      api
        .readConversation({
          conversationId: item.conversationId,
          isRead: 0,
          shopId: this.shopId,
        })
        .then((res) => {
          console.log(res);
          this.getConversationList(this.filters);
        });
    },
    //标记某一会话
    pinned(item) {
      this.filters.shopId = this.shopId;
      var params = {
        conversationId: item.conversationId,
        shopId: this.shopId,
        pinned: item.pinned == "false",
      };
      api.pinned(params).then((res) => {
        console.log(res);
        this.getConversationList(this.filters);
      });
    },

    // 商店列表右键菜单
    talkShopMenu(event) {
      let items = {
        items: [
          {
            label: this.$t("chat.cancelauthorization"),
            onClick: () => {
              window.open(
                "https://erp.shopsbu.com/cus/cancel/authorize/url/get",
                "_blank"
              );
            },
          },
        ],
        event: event,
        zIndex: 10000,
      };
      this.$contextmenu(items);
      return false;
    },

    //websock链接
    connectWebsocket() {
      const wsuri = "wss://m.shopsbu.com/websocket/server-endpoint/"+this.userId;
      console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      console.log(this.websock);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log(this.$t('other.a371'));
      // this.$message.success("websock链接成功");
    },
    websocketonerror() {
      //连接建立失败重连
      // this.connectWebsocket();
      this.$message.warning("websock链接失败,请刷新一下页面");
    },
    websocketonmessage(e) {
      //数据接收
      const redata = e.data;
      console.log(redata);
      
      if(redata.type == 'shopee-message'){
        if (this.searchFilters.queryType != 1) {
              this.getConversationList(this.filters);
              if(this.conversationData.unreadCount!=0){
                 this.getConversation(this.conversationHistoryParams);
              }
             
      }
      }
      
      
      
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
  },
  destroyed() {
    clearInterval(this.unread);
    clearInterval(this.upload);
  },
};
</script>

    <style lang="scss" scoped>
@import "~@assets/scss/mixins";
.search-text {
  color: yellow;
}
.center-cc{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.answerbody{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.message_sty :hover{
  // background:  #f4f4f4;
  font-weight: 600;
  
}
.tex-tare{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 50px;
}
.tex-tare-yh{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 50px;
}
.tex-one{
  width: 80px;
  height: 25px;
   display: flex;
  align-items: center;
  justify-content: center;
  color: gray;
  cursor: pointer;
  background:  #f4f4f4;
  border-radius: 20px;
  margin-right: 10px;
}
.el-scrollbar{
      height: 90%;
      .scrollbar-wrap{
        overflow-x: hidden;
      }
      .el-scrollbar__bar{
        
      }
    }

.tex-two{
  width: 80px;
  height: 25px;
   display: flex;
  align-items: center;
  justify-content: center;
  color: gray;
  cursor: pointer;
   background:    #f4f4f4;
  border-radius: 20px;
  
}
.mes{
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
}
.mes-zdy{
  // width: 180px;
  // height: 30px;
  border: 1px solid #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f4f4f4;
  cursor: pointer;
  background:  #409eff;
  border-radius: 20px;
}
.mes-add{
  width: 180px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #409eff;
}
.mess-one{
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
 
}
.mess-two{
  // width: 100px;
  // height: 20px;
   background: #409eff;
   color: #f4f4f4;
   font-weight: bold;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 10px;
   margin-top: 5px;
}
.order_dd_body{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.order_dd_body_text{
  font-size: 24px;
font-family: PingFang SC;
font-weight: 400;
color: #999999;
line-height: 32px;
}
.order_dd{
  display: flex;
  align-items: center;
  justify-content: center;
}
.icons-fan{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 24px;
  margin-bottom: 10px;
  
}
.pover{
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid #409eff;
  background: #409eff;
  border-radius: 20px;
  margin: 5px 0px;
  color: #f4f4f4;
  // font-weight: bold;
  
}
.pover_body{
  margin: 2px 5px;
}
.first_wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .first_category {
    width: 28rem;
    height: 18rem;
    box-sizing: border-box;
    padding: 5px;
    margin: 10px 10px;
    border-radius: 3px;
    border: 1px solid #eee;

    .item_category {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 4px;
      border-bottom: 1px solid #eee;
    }

    .item_category:nth-child(1) {
      font-size: 18px;
      font-weight: bold;
    }

    // .item_category:nth-child(8) {
    //   font-size: 18px;
    //   font-weight: bold;
    //   cursor: pointer;
    //   color: #409eff;
    //   text-align: right;
    // }
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.beizhu {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  color: #f4f4f4;
  font-size: 0.4rem;

  background: #409eff;

  border-radius: 0.2rem;
}

.chatWrapper {
  height: calc(100vh - 80px);
  // @include main-right-content();
  .el-form-item {
    margin-bottom: 0.2rem;
  }

  .clickOn {
    background: #ebedf1 !important;
  }
  .mouseover {
    background: #f7f8fb;
  }
  .talks-container {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 0.67rem;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #a1a3a9;
    border-radius: 3px;
  }
  .center_one {
    align-content: center;
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top {
    margin-top: 2rem;
  }
  .bottom {
    margin-bottom: 1.3rem;
  }
  .margin {
    margin-top: 1.3rem;
  }
  .word {
    width: 7rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .word_ {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .block {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .righti {
    float: right;
    width: 5.8rem;
  }
  .right_b {
    float: right;
    margin-right: 0.4rem;
  }
  .border {
    border: 2px #f4f4f4 solid;
    
  }
  .chat {
    width: 50%;
  }
  .aside_on {
    background: #409eff;
  }
  .mid {
    display: flex;
    align-items: center;
  }
  .margin-right {
    margin-right: 0.6rem;
  }

  .scrollbar /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .scrollbar /deep/ .is-horizontal {
    display: none;
  }

  .sendMessage_ctn /deep/ .el-textarea__inner {
    border: 0;
    resize: none;
  }
  .upload-demo /deep/ .el-upload-list__item {
    transition: none !important;
  }

  .dropdown_ctn /deep/ .Contextmenu_menu_28fUh{
    z-index: 10000;
  }
}
</style>
